import {
  AlertTriangle,
  ArrowRight,
  Banknote,
  Check,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  CircleX,
  CircuitBoardIcon,
  Coins,
  Command,
  CreditCard,
  File,
  FileText,
  HelpCircle,
  Image,
  Laptop,
  LayoutDashboardIcon,
  Loader2,
  LogIn,
  LucideIcon,
  LucideProps,
  Mail,
  Moon,
  MoreVertical,
  Pencil,
  Phone,
  Pizza,
  Plus,
  Repeat,
  Settings,
  SunMedium,
  TabletSmartphone,
  TicketSlash,
  Trash,
  User2Icon,
  UserCog,
  UserX2Icon,
  X,
} from 'lucide-react';

export type Icon = LucideIcon;

export const Icons = {
  dashboard: LayoutDashboardIcon,
  transaction: Repeat,
  logo: Command,
  login: LogIn,
  close: X,
  profile: User2Icon,
  spinner: Loader2,
  kanban: CircuitBoardIcon,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  trash: Trash,
  task: FileText,
  employee: UserX2Icon,
  post: FileText,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: UserCog,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  refund: Coins,
  void: TicketSlash,
  laptop: Laptop,
  device: TabletSmartphone,
  tips: Banknote,
  fail: CircleX,
  success: CheckCircle2,
  edit: Pencil,
  mail: Mail,
  phone: Phone,
  google: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      {...props}
    >
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
      <path d="M1 1h22v22H1z" fill="none" />
    </svg>
  ),
  check: Check,
  visa: ({ ...props }: LucideProps) => (
    <svg
      className="SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--20-svg"
      height="20"
      width="20"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" fill="#00579f"></path>
        <g fill="#fff" fillRule="nonzero">
          <path d="M13.823 19.876H11.8l1.265-7.736h2.023zm7.334-7.546a5.036 5.036 0 0 0-1.814-.33c-1.998 0-3.405 1.053-3.414 2.56-.016 1.11 1.007 1.728 1.773 2.098.783.379 1.05.626 1.05.963-.009.518-.633.757-1.216.757-.808 0-1.24-.123-1.898-.411l-.267-.124-.283 1.737c.475.213 1.349.403 2.257.411 2.123 0 3.505-1.037 3.521-2.641.008-.881-.532-1.556-1.698-2.107-.708-.354-1.141-.593-1.141-.955.008-.33.366-.667 1.165-.667a3.471 3.471 0 0 1 1.507.297l.183.082zm2.69 4.806.807-2.165c-.008.017.167-.452.266-.74l.142.666s.383 1.852.466 2.239h-1.682zm2.497-4.996h-1.565c-.483 0-.85.14-1.058.642l-3.005 7.094h2.123l.425-1.16h2.597c.059.271.242 1.16.242 1.16h1.873zm-16.234 0-1.982 5.275-.216-1.07c-.366-1.234-1.515-2.575-2.797-3.242l1.815 6.765h2.14l3.18-7.728z"></path>
          <path d="M6.289 12.14H3.033L3 12.297c2.54.641 4.221 2.189 4.912 4.049l-.708-3.556c-.116-.494-.474-.633-.915-.65z"></path>
        </g>
      </g>
    </svg>
  ),
  masterCard: ({ ...props }: LucideProps) => (
    <svg
      className="SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--20-svg"
      height="20"
      width="20"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" fill="#000"></path>
        <g fillRule="nonzero">
          <path d="M13.02 10.505h5.923v10.857H13.02z" fill="#ff5f00"></path>
          <path
            d="M13.396 15.935a6.944 6.944 0 0 1 2.585-5.43c-2.775-2.224-6.76-1.9-9.156.745s-2.395 6.723 0 9.368 6.38 2.969 9.156.744a6.944 6.944 0 0 1-2.585-5.427z"
            fill="#eb001b"
          ></path>
          <path
            d="M26.934 15.935c0 2.643-1.48 5.054-3.81 6.21s-5.105.851-7.143-.783a6.955 6.955 0 0 0 2.587-5.428c0-2.118-.954-4.12-2.587-5.429 2.038-1.633 4.81-1.937 7.142-.782s3.811 3.566 3.811 6.21z"
            fill="#f79e1b"
          ></path>
        </g>
      </g>
    </svg>
  ),
  jcb: ({ ...props }: LucideProps) => (
    <svg
      className="SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--20-svg"
      height="20"
      width="20"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#F5F6F8" d="M0 0h32v32H0z"></path>
      <g clipPath="url(#bi_jcb__a)">
        <path
          d="M5 24h4.4c1.001 0 2.2-1.194 2.2-2.133V8H7.2C6.199 8 5 9.195 5 11.2V24Z"
          fill="#047AB1"
        ></path>
        <path
          d="M7.497 18.816A9.281 9.281 0 0 1 5 18.475v-1.173c.63.377 1.35.59 2.09.618.847 0 1.32-.576 1.32-1.365v-3.221h2.09v3.221c0 1.259-.682 2.261-3.003 2.261Z"
          fill="#fff"
        ></path>
        <path
          d="M12.7 24h4.4c1.001 0 2.2-1.194 2.2-2.133V8h-4.4c-1 0-2.2 1.195-2.2 3.2V24Z"
          fill="#D42D06"
        ></path>
        <path
          d="M12.7 14.08c.638-.597 1.738-.97 3.52-.885.968.043 1.98.32 1.98.32v1.184a4.572 4.572 0 0 0-1.903-.608c-1.353-.117-2.178.619-2.178 1.91 0 1.29.825 2.026 2.178 1.92a4.639 4.639 0 0 0 1.903-.62v1.174s-1.012.288-1.98.33c-1.782.086-2.882-.287-3.52-.885v-3.84Z"
          fill="#fff"
        ></path>
        <path
          d="M20.4 24h4.4c1 0 2.2-1.194 2.2-2.133V8h-4.4c-1.001 0-2.2 1.195-2.2 3.2V24Z"
          fill="#67B637"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.9 17.28c0 .854-.682 1.387-1.595 1.387H20.4v-5.333h3.553l.253.01c.803.043 1.397.502 1.397 1.291 0 .619-.407 1.152-1.144 1.28v.032c.814.053 1.44.555 1.44 1.333Zm-2.805-3.104a1.036 1.036 0 0 0-.143-.01h-1.32v1.344h1.463c.275-.064.506-.31.506-.672 0-.363-.231-.608-.506-.662Zm-.011 2.166a.978.978 0 0 1 .176.01c.286.075.506.342.506.715 0 .373-.231.65-.506.715l-.176.021h-1.452v-1.461h1.452Z"
          fill="#fff"
        ></path>
      </g>
      <defs>
        <clipPath id="bi_jcb__a">
          <path fill="#fff" transform="translate(5 8)" d="M0 0h22v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  amex: ({ ...props }: LucideProps) => (
    <svg
      className="SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--20-svg"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#0193CE" d="M0 0h32v32H0z"></path>
        <path
          d="M17.79 18.183h4.29l1.31-1.51 1.44 1.51h1.52l-2.2-2.1 2.21-2.27h-1.52l-1.44 1.51-1.26-1.5H17.8v-.85h4.68l.92 1.18 1.09-1.18h4.05l-3.04 3.11 3.04 2.94h-4.05l-1.1-1.17-.92 1.17h-4.68v-.84zm3.67-.84h-2.53v-.84h2.36v-.83h-2.36v-.84h2.7l1.01 1.26-1.18 1.25zm-14.5 1.68h-3.5l2.97-6.05h2.8l.35.67v-.67h3.5l.7 1.68.7-1.68h3.31v6.05h-2.63v-.84l-.34.84h-2.1l-.35-.84v.84H8.53l-.35-1h-.87l-.35 1zm9.96-.84v-4.37h-1.74l-1.4 3.03-1.41-3.03h-1.74v4.04l-2.1-4.04h-1.4l-2.1 4.37h1.23l.35-1h2.27l.35 1h2.43v-3.36l1.6 3.36h1.05l1.57-3.36v3.36h1.04zm-8.39-1.85-.7-1.85-.87 1.85h1.57z"
          fill="#FFF"
        ></path>
      </g>
    </svg>
  ),
  discover: ({ ...props }: LucideProps) => (
    <svg
      className="SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--20-svg"
      height="20"
      width="20"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" fill="#ebf1f8"></path>
        <path d="M0 0h32v32H0z" fill="#fff"></path>
        <g fillRule="nonzero">
          <path
            d="M30 17.9h-1.068l-1.203-1.53h-.114v1.53h-.871v-3.8h1.286c1.006 0 1.586.4 1.586 1.12 0 .59-.363.97-1.016 1.09zm-1.286-2.65c0-.37-.29-.56-.83-.56h-.27v1.15h.25c.56 0 .85-.2.85-.59zm-5.02-1.15h2.469v.64h-1.597v.85H26.1v.65h-1.535v1.03h1.597v.64h-2.468zm-2.8 3.9-1.887-3.91h.954l1.193 2.56 1.203-2.56h.933L21.382 18h-.466zm-7.891-.01c-1.327 0-2.364-.87-2.364-2 0-1.1 1.057-1.99 2.385-1.99.373 0 .684.07 1.068.23v.88a1.586 1.586 0 0 0-1.089-.43c-.83 0-1.462.58-1.462 1.31 0 .77.622 1.32 1.503 1.32.395 0 .695-.12 1.048-.42v.88c-.394.16-.726.22-1.089.22zm-2.634-1.25c0 .74-.633 1.25-1.545 1.25-.664 0-1.141-.22-1.545-.72l.57-.47c.197.34.529.51.944.51.394 0 .674-.23.674-.53 0-.17-.083-.3-.26-.4a3.693 3.693 0 0 0-.601-.22c-.82-.25-1.1-.52-1.1-1.05 0-.62.602-1.09 1.39-1.09.498 0 .944.15 1.317.43l-.456.5a.97.97 0 0 0-.705-.3c-.373 0-.643.18-.643.42 0 .2.155.31.674.48.996.3 1.286.58 1.286 1.2zM6.086 14.1h.871v3.81h-.871zm-2.8 3.81H2V14.1h1.286c1.41 0 2.385.78 2.385 1.9 0 .57-.29 1.11-.798 1.47-.436.3-.923.44-1.597.44zm1.016-2.86c-.29-.22-.622-.3-1.192-.3h-.24v2.52h.239c.56 0 .912-.1 1.192-.3.301-.24.477-.6.477-.97s-.176-.72-.477-.95z"
            fill="#000"
          ></path>
          <path
            d="M16.75 14c-1.1 0-2 .88-2 1.97 0 1.16.86 2.03 2 2.03 1.12 0 2-.88 2-2s-.87-2-2-2z"
            fill="#f27712"
          ></path>
        </g>
      </g>
    </svg>
  ),
  maestro: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 192.756 192.756"
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path fill="#fff" d="M0 0h192.756v192.756H0V0z" />
        <path
          d="M96.378 138.172a56.433 56.433 0 0 0 18.399-41.793 56.43 56.43 0 0 0-18.399-41.793c-9.934-9.068-23.112-14.594-37.573-14.594-30.911 0-55.971 25.245-55.971 56.387 0 31.141 25.06 56.387 55.971 56.387 14.461 0 27.64-5.526 37.573-14.594z"
          fill="#3a9bd9"
        />
        <path
          d="M133.951 39.992c-14.461 0-27.641 5.526-37.573 14.594a56.75 56.75 0 0 0-5.651 5.97h11.298a56.574 56.574 0 0 1 4.27 5.971H86.46a56.654 56.654 0 0 0-3.227 5.971h26.284a56.28 56.28 0 0 1 2.375 5.97H80.863a56.329 56.329 0 0 0-1.625 5.97h34.28a57.002 57.002 0 0 1 1.26 11.941c0 6.26-1.016 12.283-2.885 17.91h-31.03a55.928 55.928 0 0 0 2.37 5.971h26.284a56.442 56.442 0 0 1-3.223 5.971H86.46a56.58 56.58 0 0 0 4.266 5.971h11.299a56.42 56.42 0 0 1-5.647 5.971c9.932 9.068 23.112 14.594 37.573 14.594 30.91 0 55.971-25.246 55.971-56.387 0-31.143-25.061-56.388-55.971-56.388z"
          fill="#cc2131"
        />
        <path
          d="M182.469 127.811c0-1.006.809-1.822 1.809-1.822.998 0 1.807.816 1.807 1.822 0 1.004-.809 1.82-1.807 1.82a1.815 1.815 0 0 1-1.809-1.82zm1.808 1.382c.758 0 1.373-.617 1.373-1.383s-.615-1.385-1.373-1.385c-.76 0-1.375.619-1.375 1.385s.616 1.383 1.375 1.383zm-.244-.584h-.371v-1.602h.672c.139 0 .281.004.404.082a.48.48 0 0 1 .203.4c0 .18-.105.35-.275.414l.293.705h-.412l-.242-.633h-.271v.634-.906h.205c.074 0 .158.004.225-.033a.217.217 0 0 0 .094-.184.205.205 0 0 0-.09-.162c-.064-.039-.168-.029-.238-.029h-.195v1.314h-.002z"
          fill="#cc2131"
        />
        <path
          d="M170.633 108.6c0-1.006.809-1.822 1.807-1.822s1.807.816 1.807 1.822-.809 1.82-1.807 1.82-1.807-.815-1.807-1.82zm1.806 1.382c.758 0 1.373-.619 1.373-1.383 0-.766-.615-1.385-1.373-1.385-.76 0-1.373.619-1.373 1.385 0 .764.614 1.383 1.373 1.383zm-.244-.584h-.371v-1.6h.672c.139 0 .283.002.404.082a.476.476 0 0 1 .203.398c0 .182-.104.35-.275.414l.293.705h-.41l-.244-.633h-.271v.634-.906h.205c.076 0 .16.006.225-.031a.222.222 0 0 0 .094-.184.202.202 0 0 0-.09-.164c-.064-.037-.168-.029-.236-.029h-.197v1.314h-.002zM51.813 110.42h-6.966l4.14-21.976-9.532 21.976h-6.352l-1.161-21.85-4.153 21.85h-6.323l5.403-28.587h10.87l.575 17.698 7.664-17.698h11.327l-5.492 28.587zM129.664 110.135c-1.906.527-3.396.754-5.006.754-3.564 0-5.51-1.801-5.51-5.105 0-.654.072-1.35.205-2.086l.424-2.273.326-1.84 3.229-17.753h6.928l-1.004 5.339h3.555l-.955 5.652h-3.57l-1.836 9.7a5.482 5.482 0 0 0-.119.963c0 1.201.721 1.723 2.377 1.723.793 0 1.408-.072 1.879-.217l-.923 5.143zM150.01 87.362c-.584-.232-.721-.232-.789-.251-.369-.082-.566-.13-.6-.136a3.89 3.89 0 0 0-.701-.058c-2.287 0-3.936 1.026-6.068 3.775l.615-3.523h-6.309l-4.246 23.25h6.971c2.494-14.219 3.562-16.709 6.906-16.709.252 0 .543.02.881.059l.814.167 2.526-6.574zM102.049 94.516c0 2.937 1.643 4.96 5.367 6.48 2.854 1.168 3.295 1.51 3.295 2.566 0 1.447-1.258 2.1-4.045 2.1-2.104 0-4.059-.285-6.316-.92l-.967 5.363.312.053 1.291.238c.416.072 1.029.141 1.842.203 1.676.131 2.973.193 3.887.193 7.436 0 10.871-2.455 10.871-7.758 0-3.191-1.436-5.062-4.967-6.471-2.955-1.177-3.297-1.438-3.297-2.523 0-1.253 1.172-1.897 3.449-1.897 1.385 0 3.273.131 5.064.349l1.004-5.382c-1.824-.25-4.592-.455-6.201-.455-7.884.001-10.613 3.573-10.589 7.861zM74.459 110.42H68.67l.135-2.41c-1.763 1.908-4.113 2.812-7.307 2.812-3.775 0-6.366-2.59-6.366-6.35 0-5.664 4.501-8.965 12.237-8.965.793 0 1.8.063 2.838.179.216-.764.275-1.094.275-1.51 0-1.539-1.215-2.115-4.468-2.115-1.989 0-4.237.252-5.789.648l-.965.247-.625.15.966-5.227c3.473-.896 5.765-1.235 8.34-1.235 5.987 0 9.151 2.362 9.151 6.82 0 1.147-.105 2.018-.566 4.606l-1.456 8.248-.245 1.48-.178 1.182-.119.809-.069.631zm-5.082-10.358a12.542 12.542 0 0 0-1.557-.096c-3.948 0-5.948 1.189-5.948 3.537 0 1.447.976 2.371 2.499 2.371 2.84.001 4.886-2.374 5.006-5.812zM97.312 109.918a27.013 27.013 0 0 1-7.138.943c-7.788-.006-11.847-3.578-11.847-10.416 0-7.981 5.164-13.857 12.174-13.857 5.735 0 9.397 3.291 9.397 8.451 0 1.713-.25 3.383-.855 5.74H85.192a4.452 4.452 0 0 0-.067.73c0 2.695 2.065 4.07 6.111 4.07 2.488 0 4.737-.455 7.234-1.471l-1.158 5.81zm-3.71-13.834c.038-.484.058-.88.058-1.186 0-1.888-1.221-2.996-3.295-2.996-2.216 0-3.801 1.486-4.444 4.168l7.681.014zM171.664 99.879c-1.043 7.734-6.404 11.164-13.531 11.164-7.881 0-11.064-4.816-11.064-10.717 0-8.24 5.391-13.823 13.717-13.823 7.227 0 11.064 4.591 11.064 10.493 0 1.436-.002 1.531-.186 2.883zm-7.174-2.975c0-2.432-.98-4.728-3.836-4.728-3.555 0-5.758 4.233-5.758 7.97 0 3.152 1.51 5.27 4 5.225 1.51 0 4.73-2.072 5.367-5.691.149-.844.227-1.77.227-2.776z"
          fill="#fff"
        />
      </g>
    </svg>
  ),
  Comingsoon: ({ ...props }: LucideProps) => (
    <svg
      id="Layer_1"
      enableBackground="new 0 0 66 66"
      viewBox={'0 0 66 66'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path d="m14.95 23.62c-.05 0-.09-.01-.14-.04-.11-.08-.14-.23-.06-.34l11.71-17.23c.08-.11.23-.14.34-.07l17.15 11.41c.11.08.14.23.07.34s-.23.14-.34.07l-16.96-11.28-11.57 17.03c-.04.07-.12.11-.2.11z" />
        </g>
        <g>
          <path
            d="m64.24 50.43c-.05.66-.54 1.22-1.22 1.34l-52.9 10.05c-.82.16-1.61-.38-1.76-1.2l-2.69-14.18-3.89-20.46c-.16-.82.38-1.61 1.2-1.77l52.9-10.04c.82-.16 1.61.38 1.76 1.2l.41 2.15 2.61 13.76 3.56 18.72c.03.15.04.29.02.43z"
            fill="#ffcd3b"
          />
        </g>
        <g>
          <path
            d="m60.67 31.29c-.28.36-.63.68-1.04.89-.62.33-1.41.39-2.03.06s-1.02-1.09-.84-1.76c.12-.42.42-.76.62-1.15s.25-.92-.07-1.22c-.33-.29-.85-.18-1.22-.38-.4-.21-.55-.72-.52-1.16.04-.44.22-.87.35-1.29.12-.43.18-.91-.03-1.31-.36-.71-1.31-.81-1.99-1.22-.55-.34-.94-.92-1.04-1.57-.09-.64.12-1.32.55-1.8l4.66-1.85z"
            fill="#fcb910"
          />
        </g>
        <g>
          <path
            d="m57.17 36.58c-.41 0-.81-.09-1.16-.27-.94-.47-1.45-1.57-1.17-2.5.1-.33.29-.62.47-.89.12-.18.23-.35.32-.53.19-.39.2-.93-.12-1.12-.16-.09-.37-.1-.6-.1s-.49-.01-.73-.11c-.67-.28-.84-1.15-.63-1.82.11-.36.31-.67.49-.98.13-.21.25-.4.34-.6.22-.45.29-1.04-.03-1.38-.26-.27-.67-.3-1.12-.34-.24-.02-.49-.04-.73-.1-1.23-.3-1.89-1.57-1.98-2.63-.1-1.15.3-2.3.62-3.23.04-.13.18-.19.31-.15s.19.18.15.31c-.32.93-.69 1.98-.6 3.02.08.89.61 1.96 1.61 2.2.2.05.42.07.65.08.52.04 1.05.08 1.43.49.51.53.38 1.37.11 1.92-.11.23-.24.44-.37.65-.18.29-.35.56-.44.87-.14.46-.05 1.05.36 1.23.16.07.35.07.55.07.27 0 .57.01.84.17.57.35.58 1.16.3 1.75-.1.21-.23.4-.35.59-.17.26-.33.5-.41.76-.22.7.2 1.56.92 1.92.67.34 1.57.26 2.3-.18.64-.38 1.19-1.04 1.58-1.9.19-.43.36-.91.51-1.51.03-.13.17-.21.3-.18s.21.17.17.3c-.16.63-.34 1.14-.54 1.59-.44.95-1.05 1.69-1.78 2.12-.46.33-1.02.48-1.57.48z"
            fill="#fcb910"
          />
        </g>
        <g>
          <path
            d="m38.38 50.07-6.76 1.28c1.48-.93 2.98-1.81 4.67-1.76.72.02 1.41.21 2.09.48z"
            fill="#fcb910"
          />
        </g>
        <g>
          <path
            d="m23.93 52.81-16.46 3.13-1.8-9.49c.03.04.05.07.08.1 1.24 1.4 3.13 2.19 4.99 2.08 1.66-.1 3.25-.85 4.91-.75 3.22.2 5.47 3.49 8.28 4.93z"
            fill="#fcb910"
          />
        </g>
        <g>
          <path
            d="m58.53 20.05-55.86 10.6-.89-4.67c-.16-.82.38-1.61 1.2-1.77l52.9-10.04c.82-.16 1.61.38 1.77 1.2z"
            fill="#efa707"
          />
        </g>
        <g>
          <path
            d="m64.24 50.43v.01c-.01.07-.01.12-.03.18 0 .03-.01.07-.02.09-.01.05-.03.1-.05.14-.02.07-.05.12-.08.18-.03.07-.07.12-.12.18-.1.15-.25.27-.41.36-.07.05-.15.08-.23.12-.08.03-.17.05-.26.07l-52.9 10.05c-.82.16-1.61-.38-1.76-1.2l-.89-4.67h.01l16.46-3.13 7.68-1.46 6.76-1.28 24.96-4.74.86 4.67c.03.15.04.29.02.43z"
            fill="#efa707"
          />
        </g>
        <g>
          <path
            d="m64.24 50.43v.01c-.01.07-.01.12-.03.18 0 .03-.01.07-.02.09-.01.05-.03.1-.05.14-.02.07-.05.12-.08.18-.03.07-.07.12-.12.18-.1.15-.25.27-.41.36-.07.05-.15.08-.23.12-.08.03-.17.05-.26.07l-52.9 10.05c-.82.16-1.61-.38-1.76-1.2l-.89-4.67 16.46-3.13c.77.4 1.59.65 2.48.66 1.89.03 3.54-1.09 5.2-2.12l6.76-1.28c2.3.92 4.41 2.83 6.84 2.45 2.49-.38 4.17-3.06 6.67-3.33 1.65-.18 3.19.74 4.75 1.29 2.42.87 5.15.81 7.59-.05z"
            fill="#db9405"
          />
        </g>
        <g>
          <g>
            <path
              d="m6.4 28.3-1.95.37c-.29.05-.56-.13-.62-.42l-.36-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.14.56-.43.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m11.38 27.35-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.14.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m16.35 26.41-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m21.32 25.46-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m26.3 24.52-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.14.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m31.27 23.58-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m36.25 22.63-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.14.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m41.22 21.69-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m46.19 20.74-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m51.17 19.8-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.14.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m56.14 18.86-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.28-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m12.37 59.74-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m17.34 58.8-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m22.32 57.85-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m27.29 56.91-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m32.27 55.97-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.28-.14.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m37.24 55.02-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m42.21 54.08-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m47.19 53.13-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m52.16 52.19-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.56-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m57.14 51.24-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.05.29-.14.57-.42.62z"
              fill="#f4eded"
            />
          </g>
          <g>
            <path
              d="m62.11 50.3-1.95.37c-.29.05-.56-.13-.62-.42l-.37-1.95c-.05-.29.13-.56.42-.62l1.95-.37c.29-.05.56.13.62.42l.37 1.95c.06.29-.13.57-.42.62z"
              fill="#f4eded"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="m18.53 37.55c.24.29.19.72-.11.97-.53.43-1.16.73-1.85.86-2.25.43-4.42-1.05-4.85-3.3s1.05-4.42 3.3-4.85c.69-.13 1.38-.08 2.04.12.36.12.57.51.45.87-.12.37-.51.57-.88.46-.43-.15-.9-.17-1.35-.08-1.49.28-2.48 1.73-2.2 3.23.29 1.5 1.74 2.48 3.23 2.2.45-.09.89-.28 1.23-.57.31-.25.74-.21.99.09z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m18.46 34.8c-.43-2.25.97-4.41 3.13-4.81 2.15-.41 4.26 1.09 4.68 3.33.43 2.25-.98 4.41-3.14 4.82-2.15.4-4.24-1.09-4.67-3.34zm1.36-.26c.29 1.5 1.66 2.5 3.05 2.23 1.41-.27 2.32-1.69 2.03-3.2-.28-1.5-1.66-2.5-3.06-2.23-1.39.27-2.3 1.7-2.02 3.2z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m33.96 35.38-.9-4.76-1.36 2.79c-.1.2-.28.34-.49.38s-.44-.02-.6-.18l-2.29-2.1.9 4.76c.07.37-.17.73-.56.81-.37.07-.73-.18-.8-.55l-1.29-6.8c-.07-.36.16-.73.56-.81.21-.04.42.02.59.17l3.15 2.88 1.88-3.83c.09-.2.27-.33.48-.37.4-.08.75.18.82.54l1.29 6.8c.07.37-.17.73-.56.81s-.75-.17-.82-.54z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m36.26 34.94-1.29-6.8c-.07-.37.17-.73.55-.8.37-.07.73.17.8.55l1.29 6.8c.07.37-.17.73-.55.8-.37.07-.73-.18-.8-.55z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m43.49 33.97-4.47-4.36.88 4.64c.07.37-.19.74-.56.81s-.73-.18-.8-.55l-1.29-6.8c-.07-.35.15-.73.56-.81.21-.04.44.02.6.19l4.47 4.36-.88-4.64c-.07-.37.17-.73.56-.81.37-.07.73.17.8.55l1.29 6.8c.07.36-.17.73-.55.8-.21.04-.44-.02-.61-.18z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m46.68 32.43c-.91-.62-1.53-1.57-1.74-2.66-.21-1.08.02-2.19.64-3.1.62-.93 1.57-1.54 2.66-1.75 1.08-.21 2.19.02 3.11.65.15.1.24.26.27.43s.01.36-.11.53c-.11.17-.26.26-.44.29-.17.03-.36.01-.51-.11-.61-.41-1.35-.56-2.07-.43-.73.14-1.36.55-1.77 1.16-.42.61-.58 1.35-.44 2.07s.56 1.35 1.17 1.77c.63.44 1.37.57 2.07.44.62-.12 1.18-.44 1.61-.94l-.27-1.43-1.7.32c-.37.07-.74-.17-.82-.55s.19-.73.56-.81l2.37-.45c.37-.07.73.17.8.55l.46 2.4c.04.19 0 .37-.11.53-.64.94-1.61 1.54-2.65 1.73-1.02.2-2.15 0-3.09-.64z"
                fill="#1b38ab"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="m24.64 46.94.02.12c.13.67-.02 1.37-.4 1.92-.42.61-1.06 1.02-1.83 1.17l-.09.02c-1 .15-1.96-.24-2.54-1.04-.06-.09-.1-.19-.11-.28-.05-.26.04-.53.28-.69.08-.06.18-.09.27-.11.26-.05.54.04.7.28.26.37.71.55 1.19.47l.06-.01c.41-.08.72-.27.92-.56.19-.28.26-.59.2-.91l-.01-.05c-.14-.53-1.24-.81-1.71-.86l-.05-.01c-1.28-.2-2.03-.85-2.23-1.89l-.02-.09c-.09-.6.08-1.19.51-1.65.36-.41.89-.71 1.5-.83l.1-.02c.49-.08 1.03.02 1.49.25.2.11.33.29.37.48.03.14.01.3-.06.43-.11.2-.29.33-.5.37-.14.03-.29.02-.43-.05-.2-.11-.45-.14-.66-.12l-.07.01c-.57.11-.96.48-.89.91l.01.05c.11.57.59.7 1.08.8.38.03 2.53.3 2.9 1.89z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m25.32 45.4c-.43-2.25.97-4.41 3.13-4.81 2.15-.41 4.26 1.09 4.68 3.33.43 2.25-.98 4.41-3.14 4.82-2.15.41-4.25-1.09-4.67-3.34zm1.36-.26c.29 1.5 1.66 2.5 3.05 2.23 1.41-.27 2.32-1.69 2.03-3.2-.28-1.5-1.66-2.5-3.06-2.23-1.4.28-2.31 1.7-2.02 3.2z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m34.06 43.74c-.43-2.25.97-4.41 3.13-4.81 2.15-.41 4.26 1.09 4.68 3.33.43 2.25-.98 4.41-3.14 4.82s-4.24-1.09-4.67-3.34zm1.37-.26c.29 1.5 1.66 2.5 3.05 2.23 1.41-.27 2.32-1.69 2.03-3.2-.28-1.5-1.66-2.5-3.06-2.23s-2.31 1.7-2.02 3.2z"
                fill="#1b38ab"
              />
            </g>
            <g>
              <path
                d="m48.41 44.94-4.47-4.36.88 4.64c.07.37-.19.74-.56.81s-.73-.18-.8-.55l-1.29-6.8c-.07-.35.15-.73.56-.81.21-.04.44.02.6.19l4.47 4.36-.88-4.64c-.07-.37.17-.73.56-.81.37-.07.73.17.8.55l1.29 6.8c.07.36-.17.73-.55.8-.22.05-.45-.02-.61-.18z"
                fill="#1b38ab"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="m30.37 7.15c0 .05 0 .11-.01.16-.08 1.58-1.39 2.83-2.99 2.83-1.64 0-2.98-1.32-2.99-2.96v-.03c0-1.65 1.34-2.99 2.99-2.99 1.66 0 3 1.34 3 2.99z"
            fill="#fe515e"
          />
        </g>
        <g>
          <path
            d="m30.36 7.32c-.08 1.58-1.39 2.83-2.99 2.83-1.64 0-2.98-1.32-2.99-2.96.07.18.17.35.31.48.29.29.75.42 1.12.24.21-.1.4-.29.64-.29.23.01.4.2.5.41.09.21.14.44.26.63.12.2.35.35.57.27.21-.07.29-.31.38-.51.08-.2.22-.43.44-.42.18.01.31.17.48.25.29.14.65-.02.84-.27.2-.25.26-.59.33-.9.03.07.07.15.11.24z"
            fill="#f83b4d"
          />
        </g>
        <g>
          <path d="m45.87 55.27c-.11 0-.22-.08-.24-.2-.03-.13.06-.26.19-.29l17.15-3.26c.56-.1.98-.56 1.02-1.12.02-.12.01-.24-.01-.36l-6.58-34.63c-.13-.69-.79-1.14-1.48-1.01l-52.89 10.05c-.33.06-.62.25-.81.53s-.26.62-.2.95l5.38 28.3c.03.13-.06.26-.19.29s-.26-.06-.29-.19l-5.37-28.3c-.09-.46.01-.93.27-1.32s.66-.65 1.13-.74l52.9-10.04c.95-.18 1.87.45 2.05 1.4l6.58 34.63c.03.18.04.35.01.5-.06.76-.64 1.41-1.41 1.55l-17.15 3.26c-.03 0-.05 0-.06 0z" />
        </g>
        <g>
          <path
            d="m13.52 48.06c-.47 0-.9.23-1.21.6s-.5.87-.5 1.43c0-1.12-.76-2.03-1.71-2.03.47 0 .9-.23 1.21-.59.31-.37.5-.87.5-1.43 0 .56.19 1.06.5 1.43.31.36.74.59 1.21.59z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="m60.67 35.5c-.47 0-.9.23-1.21.6s-.5.87-.5 1.43c0-1.12-.76-2.03-1.71-2.03.47 0 .9-.23 1.21-.59.31-.37.5-.87.5-1.43 0 .56.19 1.06.5 1.43.3.36.74.59 1.21.59z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="m10.35 45.78c-.26 0-.5.13-.67.33s-.28.48-.28.79c0-.62-.42-1.12-.94-1.12.26 0 .5-.13.67-.33s.28-.48.28-.79c0 .31.11.59.28.79.16.2.4.33.66.33z"
            fill="#fff"
          />
        </g>
        <g>
          <g>
            <path
              d="m6.56 37.6c-.45.12-1.14-1.04-1.53-2.58s-.34-2.88.12-2.99 1.14 1.05 1.53 2.58c.38 1.54.33 2.88-.12 2.99z"
              fill="#fff"
            />
          </g>
          <g>
            <path
              d="m7.18 40.08c-.2.05-.46-.29-.58-.77s-.06-.91.14-.96.46.29.58.77.06.9-.14.96z"
              fill="#fff"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m58.19 44.72c.09.46-1.2 1.07-2.88 1.35-1.68.29-3.09.14-3.15-.32-.07-.46 1.22-1.07 2.88-1.35s3.07-.14 3.15.32z"
              fill="#fff"
            />
          </g>
          <g>
            <path
              d="m60.87 44.27c.04.2-.35.43-.87.52s-.97 0-1-.2c-.04-.2.35-.43.87-.52.51-.1.96 0 1 .2z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  EmptyPayment: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3000 3000"
      width="200"
      height="200"
      {...props}
    >
      <g transform="translate(335.0 1258.3333333333335) rotate(0.0 1182.5 797.5) scale(1.6756898847139532 1.6807643631589098)">
        <svg width="1411.359" height="948.973" viewBox="0 0 1411.359 948.973">
          <path d="M1154.963 2h254.396v944.973h-254.396z" fill="#bfdbfb" />
          <path
            d="M1409.359 948.973h-254.396a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h254.396a2 2 0 0 1 2 2v944.973a2 2 0 0 1-2 2zm-252.396-4h250.396V4h-250.396z"
            fill="#0b122d"
          />
          <path d="M770.642 209.155h254.396v737.818H770.642z" fill="#bfdbfb" />
          <path
            d="M1025.038 948.973H770.642a2 2 0 0 1-2-2V209.155a2 2 0 0 1 2-2h254.396a2 2 0 0 1 2 2v737.818a2 2 0 0 1-2 2zm-252.396-4h250.396V211.155H772.642z"
            fill="#0b122d"
          />
          <path d="M386.321 665.661h254.396v281.312H386.321z" fill="#bfdbfb" />
          <path
            d="M640.717 948.973H386.321a2 2 0 0 1-2-2V665.661a2 2 0 0 1 2-2h254.396a2 2 0 0 1 2 2v281.312a2 2 0 0 1-2 2zm-252.396-4h250.396V667.661H388.321z"
            fill="#0b122d"
          />
          <path d="M2 497.221h254.396v449.752H2z" fill="#bfdbfb" />
          <path
            d="M256.397 948.973H2a2 2 0 0 1-2-2V497.221a2 2 0 0 1 2-2h254.396a2 2 0 0 1 2 2v449.752a2 2 0 0 1-2 2zM4 944.973h250.396V499.221H4z"
            fill="#0b122d"
          />
        </svg>
      </g>
      <g transform="translate(353.33333333333337 438.33333333333337) rotate(0.0 455.8333333333333 410.00000000000006) scale(1.6675049918453821 1.668392707089245)">
        <svg width="546.725" height="491.491" viewBox="0 0 546.725 491.491">
          <path
            d="m245.719 245.742-90.292 226.409a243.779 243.779 0 0 0 134.739 13.254c103.795-19.249 183.829-103.84 197.307-208.541z"
            fill="#bfdbfb"
          />
          <path
            d="M245.661 491.502c-31.018 0-61.858-5.881-90.976-17.493a2.001 2.001 0 0 1-1.116-2.599l90.292-226.409a1.994 1.994 0 0 1 2.113-1.243l241.753 31.122a1.996 1.996 0 0 1 1.728 2.239c-6.667 51.795-29.253 99.319-65.315 137.434s-82.264 63.295-133.61 72.818a246.06 246.06 0 0 1-44.869 4.131zm-87.633-20.475c41.956 16.333 87.473 20.625 131.773 12.412 102.937-19.09 181.236-101.283 195.424-204.848l-238.224-30.667-88.974 223.103z"
            fill="#0b122d"
          />
          <path
            d="m300.976 228.326 241.822 30.59a243.758 243.758 0 0 0-2.159-75.037 243.768 243.768 0 0 0-58.29-118.395z"
            fill="#fdf151"
          />
          <path
            d="M542.801 260.917a1.98 1.98 0 0 1-.254-.016l-241.821-30.59a2.002 2.002 0 0 1-1.085-3.473L481.013 63.996a2 2 0 0 1 2.824.152 245.685 245.685 0 0 1 58.768 119.366 245.439 245.439 0 0 1 2.177 75.653 2 2 0 0 1-1.981 1.749zm-237.233-34.026 235.488 29.789a241.363 241.363 0 0 0-2.385-72.436 241.683 241.683 0 0 0-56.48-115.93z"
            fill="#0b122d"
          />
          <path
            d="M245.719 245.742 426.568 82.319C369.869 19.574 284.422-9.341 201.272 6.08 69.797 30.463-18.327 158.714 6.056 290.189c15.26 82.285 71.868 151.161 149.64 182.069z"
            fill="#ee83f9"
          />
          <path
            d="M155.696 474.259a1.98 1.98 0 0 1-.738-.142c-38.473-15.29-72.729-40.311-99.068-72.357-26.339-32.047-44.251-70.501-51.8-111.206-11.89-64.113 2.131-129.356 39.479-183.712C80.918 52.487 136.795 16.003 200.908 4.114c41.134-7.63 83.864-4.557 123.572 8.879 39.709 13.437 75.523 36.946 103.571 67.985a1.998 1.998 0 0 1-.142 2.825L247.405 246.914l-89.851 226.083a1.996 1.996 0 0 1-1.858 1.262zM245.064 4.065a238.114 238.114 0 0 0-43.428 3.981C138.574 19.741 83.609 55.632 46.865 109.108S-3.672 226.763 8.023 289.825c15.121 81.539 69.843 148.622 146.556 179.829l89.281-224.65c.113-.285.29-.54.518-.745L423.737 82.182C377.754 32.153 312.141 4.065 245.064 4.065z"
            fill="#0b122d"
          />
        </svg>
      </g>
      <g transform="translate(1103.3333333333335 188.33333333333334) rotate(0.0 745.0 1332.5) scale(1.6710630203847259 1.6655833604159895)">
        <svg width="891.648" height="1600.04" viewBox="0 0 891.648 1600.04">
          <path
            d="M634.715 1439.956c-257.032-19.891-546.089-189.634-487.218-474.629 37.197-142.054 132.537-228.793 268.099-322.366 41.442-27.455 97.285-16.12 124.74 25.313 27.455 41.435 16.123 97.281-25.312 124.737-72.306 47.911-125.621 95.664-158.463 141.934-75.649 99.615-27.181 200.535 74.863 258.142 56.767 33.329 131.335 57.396 209.964 67.771 107.825 16.872 77.812 178.327-6.674 179.099z"
            fill="#c66a52"
          />
          <path
            d="M634.716 1441.956c-.052 0-.104-.002-.156-.006-83.413-6.455-166.815-28.061-241.188-62.479-79.867-36.962-145.261-87.311-189.111-145.604-28.317-37.645-47.85-78.662-58.054-121.912-10.982-46.547-11.207-96.017-.669-147.035l.024-.102c17.568-67.093 49.494-126.032 97.603-180.185 40.379-45.453 91.607-88.315 171.295-143.321 42.323-28.037 99.525-16.43 127.543 25.854 13.574 20.485 18.358 45.03 13.472 69.113s-18.86 44.822-39.346 58.396c-72.1 47.775-125.237 95.357-157.937 141.424-30.7 40.427-42.347 83.847-33.719 125.619 10.357 50.144 48.688 96.178 107.935 129.624 56.568 33.213 130.869 57.188 209.242 67.529 24.778 3.876 44.372 15.731 56.709 34.29 10.754 16.176 15.78 37.327 14.154 59.556-3.143 42.943-31.471 88.812-77.78 89.236h-.017zM149.445 965.782c-20.267 98.176-.749 187.566 58.013 265.682 85.425 113.562 249.166 192.68 427.324 206.491 43.865-.46 70.732-44.393 73.741-85.527 2.638-36.05-13.442-81.146-67.444-89.596-78.844-10.401-153.677-34.561-210.667-68.021-60.237-34.005-99.262-80.989-109.855-132.281-8.868-42.936 3.031-87.473 34.412-128.794 32.947-46.419 86.438-94.343 158.951-142.391 19.595-12.984 32.96-32.821 37.635-55.857 4.674-23.036.098-46.514-12.886-66.108-26.801-40.447-81.517-51.549-121.969-24.75-137.996 95.254-230.857 182.219-267.255 321.154z"
            fill="#0b122d"
          />
          <path
            d="m634.143 1260.207 90.31 8.633-30.599 320.104s-59.819-2.271-73.148-41.966c-16.708-49.756-23.511-88.492-27.124-124.071-3.142-30.939 25.002-27.788 25.002-27.788-5.356-47.239 18.14-79.289 15.56-134.911z"
            fill="#fff"
          />
          <path
            d="M693.855 1590.943h-.077c-2.499-.096-61.355-2.789-74.968-43.328-18.518-55.142-24.272-95.503-27.219-124.505-1.041-10.257 1.107-18.107 6.387-23.333 5.987-5.925 14.292-6.745 18.376-6.752-2.207-23.238 2.37-42.799 7.207-63.471 4.84-20.685 9.845-42.074 8.584-69.254a2.002 2.002 0 0 1 2.188-2.084l90.311 8.633a2.001 2.001 0 0 1 1.801 2.182l-30.6 320.104a2.001 2.001 0 0 1-1.99 1.81zm-77.346-193.909c-3.396 0-10.729.631-15.737 5.605-4.363 4.334-6.113 11.085-5.2 20.065 2.924 28.795 8.639 68.87 27.029 123.636 11.425 34.022 59.317 39.663 69.447 40.479l30.224-316.179-86.038-8.225c.911 26.639-4.012 47.682-8.778 68.05-4.915 21.009-9.559 40.852-6.886 64.428a2.003 2.003 0 0 1-.572 1.639 1.982 1.982 0 0 1-1.638.574 19.958 19.958 0 0 0-1.851-.072z"
            fill="#0b122d"
          />
          <path
            d="m712.399 1597.889 18.506-193.594c.78-8.156-.87-16.418-5.044-23.469-6.698-11.314-9.351-26.173-7.158-45.28l18.604 1.778 6.941-72.61-35.463-3.39-8.147 85.223a50.008 50.008 0 0 0 2.17 20.053l6.33 19.7a50.01 50.01 0 0 1 2.17 20.053l-18.134 189.697 19.225 1.838z"
            fill="#0b122d"
          />
          <path
            d="M712.401 1599.889c-.063 0-.128-.003-.192-.009l-19.225-1.837a2.001 2.001 0 0 1-1.801-2.182l18.134-189.697a47.723 47.723 0 0 0-2.083-19.251l-6.33-19.7a51.706 51.706 0 0 1-2.257-20.855l8.146-85.223a2.003 2.003 0 0 1 2.182-1.801l35.463 3.39a2.001 2.001 0 0 1 1.801 2.182l-6.94 72.61a2.001 2.001 0 0 1-2.182 1.801l-16.635-1.591c-1.684 17.123.702 31.273 7.1 42.082 4.322 7.301 6.16 15.834 5.315 24.678L714.39 1598.08a2.001 2.001 0 0 1-1.989 1.81zm-17.045-5.638 15.242 1.456 18.316-191.603c.765-7.995-.887-15.692-4.774-22.26-7.094-11.984-9.592-27.638-7.425-46.525a2.003 2.003 0 0 1 2.178-1.764l16.613 1.588 6.56-68.628-31.48-3.009-7.956 83.231a47.707 47.707 0 0 0 2.083 19.251l6.33 19.7a51.703 51.703 0 0 1 2.257 20.855l-17.943 187.706z"
            fill="#0b122d"
          />
          <path d="m618.583 1395.119 10.805 58.422" fill="#fff" />
          <path
            d="M629.385 1455.541a2.001 2.001 0 0 1-1.965-1.637l-10.805-58.422a2 2 0 1 1 3.934-.726l10.805 58.422a2 2 0 0 1-1.969 2.363z"
            fill="#0b122d"
          />
          <path
            d="M583.139 1469.848c-252.228-20.229-516.367-241.313-453.898-509.327 27.137-135.012 182.982-263.315 280.347-324.052 50.639-33.561 118.896-19.709 152.454 30.933 33.557 50.643 19.705 118.9-30.937 152.457-65.086 41.135-219.114 154.1-185.892 244.89 18.328 50.088 53.434 94.376 83.31 116.76 45.301 33.943 104.885 60.489 167.868 71.835 17.173 54.007 12.72 181.904-13.251 216.503z"
            fill="#fdf151"
          />
          <path
            d="M583.139 1471.849c-.053 0-.106-.002-.16-.007-73.77-5.916-149.232-28.916-218.231-66.514-69.872-38.074-129.458-89.21-172.314-147.88-66.683-91.287-89.207-194.12-65.14-297.381 12.165-60.529 50.642-124.748 114.346-190.813 66.34-68.797 138.812-116.965 166.891-134.481 24.89-16.497 54.772-22.323 84.088-16.373 29.318 5.949 54.565 22.959 71.091 47.898 34.111 51.48 19.981 121.116-31.499 155.229-37.173 23.494-220.628 145.492-185.119 242.535 20.069 54.846 57.056 96.685 82.631 115.848 46.886 35.129 106.202 60.51 167.023 71.467a2.004 2.004 0 0 1 1.552 1.362c17.255 54.268 12.902 183.06-13.558 218.31-.38.506-.974.8-1.6.8zm-113.013-851.72c-20.994 0-41.531 6.144-59.433 18.007-113.22 70.629-254.313 197.517-279.49 322.779-23.809 102.152-1.515 203.855 64.461 294.173 85.42 116.939 237.038 200.331 386.52 212.676 11.276-15.974 19.389-52.795 21.764-98.992 2.287-44.503-1.198-87.868-9.105-113.676-61.004-11.181-120.45-36.72-167.519-71.985-26.014-19.491-63.619-62.005-83.988-117.674-14.66-40.065 4.352-88.222 56.509-143.13 46.881-49.354 106.665-89.268 130.193-104.137 49.605-32.872 63.231-100.021 30.338-149.662-15.936-24.048-40.28-40.451-68.552-46.188a109.086 109.086 0 0 0-21.697-2.191z"
            fill="#0b122d"
          />
          <path
            d="M602.627 1306.559a1.76 1.76 0 0 1-.205-.011c-69.9-7.115-145.698-35.585-202.758-76.156-50.418-35.849-111.53-99.01-116.349-196.328-2.424-48.965 21.605-97.574 73.46-148.604 43.967-43.268 100.363-80.597 145.679-110.591 33.646-22.271 62.704-41.504 75.684-56.052a2 2 0 0 1 2.984 2.663c-13.324 14.935-41.186 33.376-76.461 56.725-45.171 29.899-101.389 67.11-145.08 110.106-50.995 50.184-74.635 97.795-72.27 145.555 8.575 173.228 198.08 256.748 315.515 268.703a2 2 0 0 1-.199 3.989z"
            fill="#0b122d"
          />
          <path
            d="M478.075 771.627c-16.206 16.717-59.456 100.822-66.604 140.941 13.585-13.072 28.281-25.867 43.705-38.48l22.898-102.461z"
            fill="#0b122d"
          />
          <path
            d="M411.47 914.568a1.998 1.998 0 0 1-1.967-2.351c7.145-40.099 50.194-124.506 67.137-141.982a2.001 2.001 0 0 1 3.388 1.828l-22.897 102.461a2 2 0 0 1-.687 1.112c-16.606 13.58-30.863 26.132-43.585 38.373a1.998 1.998 0 0 1-1.388.559zm62.81-135.13c-17.703 24.351-50.626 90.44-59.516 127.237 11.456-10.778 24.147-21.853 38.612-33.698l20.903-93.539z"
            fill="#0b122d"
          />
          <path
            d="M374.032 1573.873c-8.087 0-16.3-1.098-24.468-3.399-47.84-13.487-78.912-53.243-65.424-101.083 75.923-269.315 193.687-657.664 256.092-817.527 18.075-46.302 70.264-69.186 116.566-51.11 46.303 18.075 69.186 70.264 51.111 116.566-61.074 156.451-176.075 536.828-250.524 800.911-11.185 39.674-44.07 55.643-83.354 55.643z"
            fill="#c66a52"
          />
          <path
            d="M374.032 1575.873a92.187 92.187 0 0 1-25.01-3.475c-24.354-6.865-44.532-20.522-56.818-38.454-13.136-19.173-16.591-41.684-9.989-65.098 81.444-288.901 195.584-662.548 256.154-817.711 8.937-22.892 26.252-40.933 48.758-50.801 22.505-9.868 47.507-10.382 70.399-1.445 47.255 18.447 70.693 71.901 52.247 119.157-58.426 149.666-170.224 516.104-250.463 800.727-10.381 36.822-40.666 57.101-85.278 57.101zm250.014-979.33c-12.005 0-23.987 2.489-35.312 7.455-21.527 9.439-38.09 26.696-46.638 48.593-60.524 155.043-174.613 528.534-256.031 817.342-6.269 22.235-3.004 43.588 9.439 61.751 11.758 17.16 31.149 30.253 54.604 36.865a88.202 88.202 0 0 0 23.925 3.324c30.179 0 68.803-9.4 81.429-54.187 80.266-284.715 192.114-651.31 250.586-801.095 17.645-45.201-4.774-96.331-49.976-113.976-10.377-4.051-21.21-6.073-32.025-6.073z"
            fill="#0b122d"
          />
          <path
            d="M521.602 644.59c22.091-56.593 85.875-84.562 142.47-62.469 56.592 22.092 84.56 85.877 62.469 142.47-53.761 137.719-218.454 758.847-218.454 758.847-51.655-2.789-154.42-13.748-210.427-61.19 0 0 118.412-464.21 192.79-688.898"
            fill="#fdf151"
          />
          <path
            d="M508.088 1485.437c-.036 0-.072 0-.108-.003-55.373-2.988-156.496-14.974-211.612-61.661a2 2 0 0 1-.645-2.021c1.184-4.643 119.279-466.848 192.829-689.032a2 2 0 0 1 3.797 1.256c-71.648 216.442-185.628 660.922-192.439 687.545 53.902 44.821 151.787 56.739 206.662 59.827 9.293-34.974 166.241-624.623 218.106-757.486 21.654-55.475-5.859-118.224-61.333-139.879-26.872-10.491-56.223-9.889-82.644 1.695-26.419 11.584-46.746 32.764-57.235 59.637a2.002 2.002 0 0 1-3.727-1.454c10.879-27.869 31.958-49.833 59.356-61.846 27.397-12.014 57.835-12.638 85.704-1.759 57.528 22.458 86.061 87.531 63.604 145.06-53.105 136.04-216.737 752.422-218.384 758.632a1.999 1.999 0 0 1-1.933 1.487z"
            fill="#0b122d"
          />
          <path
            d="m465.632 1487.983-21.817 90.727H121.949s11.098-59.782 53.499-76.822c53.131-21.353 93.58-31.802 130.342-38.777 31.965-6.065 24.673 22.224 24.673 22.224 48.891-9.819 78.14 10.506 135.168 2.649z"
            fill="#fff"
          />
          <path
            d="M443.814 1580.709H121.949a2 2 0 0 1-1.967-2.366c.462-2.485 11.793-61.061 54.721-78.312 58.844-23.648 100.767-33.204 130.715-38.887 10.741-2.039 18.543-.555 23.195 4.407 4.968 5.301 4.854 13.048 4.326 17.273 23.75-4.279 42.895-1.603 63.118 1.226 20.365 2.846 41.427 5.79 69.301 1.95a1.997 1.997 0 0 1 1.756.639c.443.49.616 1.168.462 1.811l-21.817 90.727a2 2 0 0 1-1.944 1.532zm-319.384-4h317.808l20.77-86.367c-26.993 3.334-47.575.457-67.504-2.33-20.686-2.891-40.224-5.622-64.646-.718a1.997 1.997 0 0 1-2.33-2.46c.026-.104 2.647-10.717-2.844-16.559-3.655-3.888-10.223-4.966-19.52-3.201-29.771 5.648-71.446 15.148-129.969 38.668-36.146 14.526-49.161 61.816-51.765 72.967z"
            fill="#0b122d"
          />
          <path
            d="M110.103 1598.04h194.69c8.202 0 16.866-2.431 24.661-7.262 12.507-7.751 28.039-11.809 47.197-11.445l-4.509 18.707h73.021l8.572-35.654h-85.68c-6.799 0-13.86 1.385-20.754 4.071l-20.999 8.181c-6.895 2.686-13.958 4.071-20.757 4.071H114.803l-4.7 19.331z"
            fill="#0b122d"
          />
          <path
            d="M445.163 1600.04h-73.021a1.998 1.998 0 0 1-1.944-2.469l3.918-16.26c-17.037.032-31.698 3.785-43.609 11.167-7.982 4.946-16.874 7.562-25.714 7.562h-194.69a1.998 1.998 0 0 1-1.943-2.473l4.699-19.331a2 2 0 0 1 1.943-1.527h190.741c6.591 0 13.33-1.324 20.032-3.935l20.999-8.181c7.165-2.792 14.392-4.207 21.479-4.207h85.681a1.999 1.999 0 0 1 1.944 2.468l-8.572 35.653a2 2 0 0 1-1.944 1.532zm-70.482-4h68.905l7.61-31.653h-83.143c-6.589 0-13.327 1.323-20.028 3.934l-20.999 8.181c-7.166 2.792-14.395 4.208-21.483 4.208H116.375l-3.728 15.331h192.146c7.979 0 16.362-2.473 23.606-6.962 13.155-8.153 29.404-12.104 48.289-11.745a2.001 2.001 0 0 1 1.906 2.468z"
            fill="#0b122d"
          />
          <path d="m330.464 1485.333-61.087 16.305" fill="#fff" />
          <path
            d="M269.376 1503.64a2.001 2.001 0 0 1-.515-3.933l61.087-16.306a2.001 2.001 0 0 1 1.031 3.865l-61.087 16.306a2.013 2.013 0 0 1-.517.068zm185.802-23.042a2 2 0 0 1-1.924-2.552l248.905-869.521a2 2 0 1 1 3.846 1.1L457.1 1479.146a2 2 0 0 1-1.922 1.45z"
            fill="#0b122d"
          />
          <path
            d="M257.387 657.85c-106.855.361-144.275-119.383-202.637-183.071-49.196-43.812 13.119-117.682 64.605-76.324 24.09 20.391 43.192 50.42 61.666 79.46 35.41 52.127 66.724 115.431 111.993 54.586 17.751-22.214 33.958-53.731 49.633-84.21 30.042-57.08 78.035-160.984 142.702-97.768 16.927 21.819 12.966 53.228-8.851 70.157-11.988 9.303-31.023 46.317-44.922 73.344-32.814 69.116-91.419 167.634-174.189 163.826z"
            fill="#c66a52"
          />
          <path
            d="M262.05 659.957c-1.568 0-3.132-.036-4.705-.107h-.437c-34.741 0-65.313-12.621-93.458-38.579-24.856-22.925-44.866-53.197-64.219-82.472-15.251-23.072-29.657-44.866-45.89-62.596-26.288-23.481-21.314-54.21-5.553-72.841 15.759-18.627 45.268-28.598 72.818-6.467 24.361 20.62 43.547 50.779 62.101 79.945 3.765 5.541 7.561 11.329 11.231 16.926 20.57 31.364 40 60.988 61.896 61.636 11.646.354 23.255-7.539 35.574-24.096 17.664-22.106 33.821-53.523 49.446-83.907 1.766-3.354 3.57-6.827 5.436-10.415 22.237-42.781 52.693-101.372 91.908-107.647 16.166-2.586 32.494 4.061 48.548 19.754.065.064.126.132.182.204 17.576 22.655 13.447 55.387-9.204 72.963-11.64 9.033-30.558 45.819-44.37 72.679-51.993 109.517-109.614 165.017-171.305 165.019zm-4.662-4.107c.03 0 .061 0 .091.002 61.725 2.86 119.692-51.895 172.291-162.686 14.012-27.249 33.163-64.491 45.502-74.066 20.874-16.197 24.709-46.335 8.58-67.243-15.064-14.69-30.208-20.943-45.021-18.568-37.226 5.958-67.146 63.515-88.991 105.542-1.868 3.594-3.676 7.073-5.424 10.393-15.719 30.564-31.969 62.163-49.84 84.526-13.114 17.629-25.848 26.044-38.859 25.652-23.979-.71-43.964-31.181-65.122-63.441-3.662-5.584-7.449-11.358-11.229-16.922-18.427-28.965-37.446-58.864-61.304-79.058-25.42-20.419-52.674-11.229-67.22 5.965-14.564 17.216-19.138 45.631 5.236 67.339.051.045.099.093.145.143 16.473 17.976 30.983 39.927 46.345 63.167 38.756 58.63 78.837 119.252 154.334 119.257.165 0 .348.011.485 0z"
            fill="#0b122d"
          />
          <path
            d="M257.389 677.85c-77.809.743-109.306-38.094-140.539-83.284-22.795-32.98-16.403-73.498 16.845-94.576 32.619-20.754 66.115-20.178 90.575 10.494 12.966 16.259 16.873 20.278 33.111 27.366 1.049.458 8.294-3.171 20.01-17.833 42.341-53.802 71.542-153.328 125.542-194.141 73.535-55.087 157.495 52.745 85.956 110.505-62.72 87.344-97.581 240.191-231.501 241.47z"
            fill="#5c79f7"
          />
          <path
            d="M255.239 679.86c-34.859 0-63.249-8.119-86.742-24.796-22.218-15.771-38.509-37.972-53.292-59.36-11.844-17.136-16.307-36.707-12.566-55.107 3.503-17.236 14.152-32.257 29.986-42.294 35.621-22.665 69.594-18.677 93.21 10.936 13.026 16.333 16.669 19.9 31.915 26.591 1.63-.547 7.918-4.343 18.079-17.06 16.808-21.356 31.332-49.591 46.711-79.485 22.822-44.364 46.422-90.239 79.188-115.004 38.992-29.208 79.261-13.572 100.177 13.318 20.866 26.825 26.12 69.579-11.546 100.167-16.082 22.44-30.123 48.817-44.984 76.738-21.097 39.633-42.912 80.616-71.972 111.874-33.055 35.553-70.996 53.044-115.993 53.474-.725.007-1.451.01-2.17.01zm2.131-4.01.02 2-.02-2c98.086-.937 142.003-83.44 184.473-163.227 14.975-28.132 29.119-54.705 45.423-77.41.105-.146.229-.277.368-.39 35.801-28.905 30.857-69.389 11.113-94.771-19.754-25.396-57.79-40.165-94.614-12.577-32.031 24.209-55.419 69.672-78.036 113.638-15.469 30.069-30.079 58.47-47.134 80.14-9.682 12.117-19.087 19.868-22.381 18.43-16.345-7.134-20.407-11.065-33.874-27.952-22.52-28.238-53.751-31.808-87.938-10.053-14.909 9.451-24.927 23.555-28.211 39.714-3.521 17.324.718 35.805 11.938 52.037 32.581 47.139 63.502 83.168 138.874 82.421z"
            fill="#0b122d"
          />
          <path
            d="M429.993 326.032c20.132-8.053 96.492-35.581 96.492-35.581l85.712-13.768s102.065-9.378 131.056 7.503-.805 326.92-32.212 375.238c-52.4 46.333-259.182 36.574-299.57-21.743 37.044-79.724 33.822-187.634 18.522-311.65z"
            fill="#fff"
          />
          <path
            d="M584.628 690.609c-18.388 0-36.82-1.105-54.077-3.196-60.399-7.315-104.401-25.026-120.724-48.593a1.997 1.997 0 0 1-.169-1.981c39.456-84.917 31.418-204.644 18.351-310.562a2.003 2.003 0 0 1 1.242-2.102c19.934-7.973 95.792-35.33 96.556-35.605.117-.042.238-.074.361-.093l85.713-13.768c.045-.007.09-.013.135-.017 4.193-.385 103.037-9.241 132.245 7.766 3.493 2.035 6.179 7.172 8.209 15.706 7.129 29.965 5.804 104.223-3.376 189.182-7.344 67.959-20.755 149.139-36.375 173.169a2.019 2.019 0 0 1-.352.408c-23.442 20.728-75.407 29.687-127.739 29.687zm-170.855-53.143c16.008 21.855 59.673 39.002 117.258 45.976 65.342 7.914 147.527 1.742 178.48-25.335 27.249-42.661 54.608-293.69 39.066-359.017-2.165-9.103-4.638-12.189-6.331-13.174-27.806-16.193-126.709-7.522-129.799-7.246l-85.46 13.727c-4.016 1.448-73.52 26.53-94.82 34.925 8.643 70.456 11.882 124.897 10.192 171.218-2.042 55.999-11.395 101.459-28.587 138.927z"
            fill="#0b122d"
          />
          <path
            d="M615.586 266.335c2.663.013 18.092 85.845 12.87 114.843-11.626 104.205-12.49 242.205-57.996 369.014 46.37 16.107 149.329 16.833 174.541-25.122 14.528-34.051 30.302-286.922 29.762-343.892-.245-25.853 15.169-97.006-5.185-106.281-32.217-14.681-121.943-19.664-153.992-8.562z"
            fill="#5c79f7"
          />
          <path
            d="M642.249 762.403c-26.615 0-53.358-3.692-72.445-10.322a1.998 1.998 0 0 1-1.226-2.564c34.997-97.524 43.46-200.92 50.927-292.145 2.211-27.012 4.299-52.525 6.965-76.415.005-.044.011-.089.019-.133 4.983-27.673-8.813-106.284-12.183-112.952a2 2 0 0 1 .627-3.426c32.621-11.302 122.711-6.299 155.476 8.631 16.14 7.354 11.947 47.298 8.578 79.393-1.228 11.69-2.287 21.787-2.222 28.689.509 53.776-14.775 309.192-29.923 344.696a1.9 1.9 0 0 1-.126.246c-11.531 19.19-40.254 31.725-80.875 35.296-7.714.678-15.647 1.007-23.591 1.007zm-69.221-13.456c46.607 15.259 145.838 15.401 170.187-24.788 13.883-33.081 30.118-282.808 29.549-342.962-.067-7.131 1.003-17.332 2.243-29.145 3.064-29.193 7.262-69.175-6.258-75.336-30.755-14.014-117.359-19.103-150.389-9.175 4.805 14.508 16.848 87.188 12.076 113.924-2.655 23.812-4.74 49.275-6.946 76.232-7.438 90.875-15.862 193.795-50.462 291.25zm42.538-480.612h.01zm-.01 0h.005z"
            fill="#0b122d"
          />
          <path
            d="M402.934 325.875c33.894-26.726 121.599-40.913 121.599-40.913-6.805 27.172-15.277 48.112-13.903 93.414 4.808 158.559-22.433 288.704-107.2 351.314 0 0-47.871-45.06-83.749-28.88 0 0 69.129-51.317 88.826-110.41 16.748-50.245 21.105-108.337 12.663-161.098"
            fill="#5c79f7"
          />
          <path
            d="M403.43 731.69c-.496 0-.988-.183-1.371-.543-.47-.441-47.315-43.957-81.558-28.514a2 2 0 0 1-2.015-3.429c.687-.509 68.854-51.633 88.122-109.436 16.407-49.222 20.994-107.595 12.585-160.15a2 2 0 1 1 3.949-.632c8.508 53.17 3.864 112.233-12.739 162.046-15.604 46.813-62.359 89.125-81.367 104.873 31.763-5.357 67.331 24.747 74.522 31.194 39.238-29.532 67.878-75.824 85.134-137.623 15.764-56.452 22.472-127.456 19.938-211.04-1.15-37.922 4.472-58.639 10.424-80.572a879.68 879.68 0 0 0 2.778-10.408c-15.676 2.787-88.081 16.665-117.661 39.989a2 2 0 1 1-2.477-3.141c33.912-26.74 118.916-40.735 122.518-41.317a2.001 2.001 0 0 1 2.26 2.46c-1.158 4.624-2.378 9.118-3.558 13.465-5.872 21.638-11.418 42.076-10.286 79.403 2.547 83.988-4.21 155.395-20.082 212.236-17.695 63.368-47.278 110.722-87.929 140.747a1.996 1.996 0 0 1-1.188.391z"
            fill="#0b122d"
          />
          <path
            d="M103.336 541.379c-15.921-24.065-31.339-47.78-48.586-66.601-49.196-43.812 13.119-117.682 64.605-76.324 24.09 20.391 43.192 50.42 61.666 79.46"
            fill="#c66a52"
          />
          <path
            d="M103.338 543.379a2 2 0 0 1-1.67-.896l-2.43-3.675c-15.253-23.075-29.661-44.873-45.895-62.604-26.289-23.48-21.315-54.21-5.554-72.841 15.759-18.627 45.268-28.598 72.818-6.467 24.361 20.62 43.547 50.779 62.101 79.945a2 2 0 0 1-3.375 2.147c-18.394-28.914-37.413-58.812-61.271-79.007-25.42-20.419-52.674-11.229-67.22 5.965-14.564 17.216-19.138 45.631 5.236 67.339.051.045.099.093.145.143 16.476 17.978 30.986 39.932 46.351 63.175l2.429 3.673a2 2 0 0 1-1.666 3.103z"
            fill="#0b122d"
          />
          <path
            d="M64.619 424.203c-9.73-13.905-29.117-23.001-40.878-18.346s-25.097 25.157-20.976 38.717c3.393 11.165 14.815 15.288 30.34 23.517 14.574 7.725 15.865-21.878 4.741-31.007-5.234-4.296-8.905-5.437-8.905-5.437"
            fill="#c66a52"
          />
          <path
            d="M37.586 471.365c-1.688 0-3.514-.499-5.418-1.508-2.366-1.254-4.636-2.412-6.796-3.514-12.424-6.338-21.399-10.917-24.521-21.188-4.359-14.342 9.215-36.036 22.153-41.158 12.481-4.94 32.691 3.966 43.253 19.059a2 2 0 0 1-3.277 2.293c-9.428-13.473-27.781-21.873-38.503-17.633-11.365 4.499-23.524 24.02-19.799 36.276 2.627 8.643 10.537 12.679 22.511 18.788a485.487 485.487 0 0 1 6.852 3.543c4.209 2.23 6.065.432 7.095-1.115 3.972-5.966 2.251-20.99-4.559-26.579-4.806-3.944-8.205-5.064-8.239-5.076a2.004 2.004 0 0 1-1.299-2.508 1.994 1.994 0 0 1 2.496-1.308c.165.051 4.105 1.309 9.579 5.8 8.527 6.998 10.302 24.451 5.352 31.887-1.737 2.609-4.122 3.941-6.88 3.941z"
            fill="#0b122d"
          />
          <path
            d="M74.062 395.914c-7.99-8.621-24.462-17.381-32.954-15.963-12.476 2.083-29.821 16.173-27.23 30.107s9.043 22.909 18.996 32.483c11.887 11.435 23.016-15.72 14.384-27.235-8.632-11.514-6.479-9.05-6.479-9.05"
            fill="#c66a52"
          />
          <path
            d="M38.735 447.278c-2.471 0-4.968-1.102-7.248-3.295-9.747-9.377-16.807-18.672-19.575-33.559-.978-5.255.507-10.891 4.291-16.297 5.622-8.03 15.728-14.67 24.576-16.148 9.463-1.581 26.444 7.615 34.749 16.576a2 2 0 1 1-2.933 2.719c-8.17-8.816-23.896-16.569-31.157-15.35-7.748 1.294-16.982 7.391-21.957 14.497-2.2 3.143-4.617 7.997-3.637 13.272 2.575 13.84 9.225 22.565 18.417 31.408 2.84 2.732 5.517 2.914 8.184.555 5.55-4.907 8.203-18.494 3.214-25.149-2.623-3.5-4.518-6.064-5.631-7.623-1.313-1.84-2.262-3.169-.742-4.4.156-.126 1.564-1.188 3.001.458.213.243.355.523.431.815.618.894 2.183 3.068 6.143 8.351 6.319 8.43 3.236 24.354-3.766 30.545-1.982 1.753-4.16 2.626-6.358 2.626z"
            fill="#0b122d"
          />
          <path
            d="M119.355 398.454c-23.092-18.655-61.748-46.057-80.907-54.652-17.805-7.987-21.283 20.672-.311 35.067 23.561 16.173 32.058 31.31 32.058 31.31"
            fill="#c66a52"
          />
          <path
            d="M70.197 412.181a2 2 0 0 1-1.746-1.021c-.082-.146-8.613-14.968-31.444-30.64-13.968-9.587-18.24-25.996-13.339-34.725 3.036-5.409 8.87-6.836 15.6-3.816 18.558 8.325 56.673 34.99 81.345 54.921a2 2 0 0 1-2.513 3.111c-24.478-19.774-62.203-46.189-80.468-54.383-4.782-2.145-8.502-1.39-10.475 2.125-3.58 6.375-.703 20.671 12.114 29.469 23.673 16.25 32.312 31.345 32.669 31.98a2 2 0 0 1-1.743 2.979z"
            fill="#0b122d"
          />
          <path
            d="M122.326 418.714c-28.267-29.844-66.552-18.154-81.22-15.365-15.022 2.857-9.365 28.873 14.111 30.133 12.257.657 18.849 4.732 18.849 4.732 1.373 19.306 16.54 29.563 27.114 25.943"
            fill="#c66a52"
          />
          <path
            d="M96.734 466.879c-3.748 0-7.682-1.247-11.32-3.656-7.45-4.935-12.24-13.55-13.247-23.758-2.083-1.028-7.947-3.497-17.057-3.985-14.93-.801-23.66-11.246-24.294-20.667-.466-6.922 3.427-12.193 9.916-13.427a203.01 203.01 0 0 0 4.418-.914c16.915-3.612 52.109-11.13 78.628 16.868a2 2 0 1 1-2.904 2.751c-24.974-26.367-58.686-19.167-74.889-15.707-1.675.357-3.185.68-4.505.931-4.51.857-7.004 4.308-6.673 9.229.519 7.708 7.886 16.264 20.518 16.942 12.622.677 19.507 4.85 19.794 5.027a2 2 0 0 1 .943 1.559c.672 9.443 4.885 17.395 11.561 21.816 4.3 2.847 9.003 3.713 12.91 2.377a2.001 2.001 0 0 1 1.295 3.785 15.707 15.707 0 0 1-5.094.83z"
            fill="#0b122d"
          />
          <path
            d="M524.532 284.962c-4.346 11.274-14.602 59.592-13.903 93.414 0 0-9.35-36.175-18.997-36.98s-33.453 6.379-39.09 16.847c-5.637 10.469 24.395-91.173 63.519-99.051l8.472 25.769z"
            fill="#5c79f7"
          />
          <path
            d="M510.628 380.376a2.003 2.003 0 0 1-1.935-1.5c-3.737-14.45-11.553-35.014-17.228-35.487-9.047-.751-31.931 6.085-37.163 15.803-.291.542-1.178 2.195-2.872 1.736-.272-.073-1.628-.533-1.568-2.381.231-7.204 28.782-93.86 65.804-101.315a1.998 1.998 0 0 1 2.295 1.336l8.472 25.769c.144.438.132.913-.034 1.344-4.419 11.464-14.452 59.59-13.769 92.654a2.001 2.001 0 0 1-2.002 2.042zm-20.541-41.039c.609 0 1.18.021 1.711.066 7.043.588 13.231 14.798 17.042 26.02 1.497-31.371 9.532-69.317 13.573-80.503l-7.678-23.355c-17.379 4.822-32.598 28.952-42.428 48.695-8.178 16.423-13.943 32.393-16.669 41.331 9.047-7.628 25.6-12.254 34.448-12.254z"
            fill="#0b122d"
          />
          <path
            d="m513.516 215.942 74.1-14.164 15.75 82.406-74.1 14.164z"
            fill="#c66a52"
          />
          <path
            d="M529.266 300.35a2.005 2.005 0 0 1-1.965-1.624L511.55 216.32a2.001 2.001 0 0 1 1.59-2.34l74.099-14.163a2 2 0 0 1 2.34 1.589l15.751 82.406a2.001 2.001 0 0 1-1.59 2.34l-74.099 14.163c-.124.024-.25.036-.375.036zm-13.411-82.818 15 78.478 70.17-13.412-15-78.478z"
            fill="#0b122d"
          />
          <path
            d="m522.536 268.476 3.95 21.974s25.901-20.102 28.411-38.617c-10.84 7.388-21.637 13.303-32.361 16.642z"
            fill="#0b122d"
          />
          <path
            d="M526.485 292.451a2.002 2.002 0 0 1-1.969-1.646l-3.949-21.975a2.002 2.002 0 0 1 1.374-2.264c9.65-3.005 20.062-8.365 31.829-16.385a1.998 1.998 0 0 1 3.108 1.922c-2.59 19.104-28.082 39.087-29.166 39.928-.356.276-.789.42-1.227.42zm-1.672-22.609 3.035 16.887c5.782-4.952 19.57-17.735 23.912-30.414-9.729 6.276-18.598 10.726-26.947 13.527z"
            fill="#0b122d"
          />
          <path
            d="M169.708 460.277c-6.204 34.095-38.352 62.492-75.856 66.784l18.601 27.996c41.25-4.452 73.398-33.856 75.812-66.289l-18.556-28.491z"
            fill="#5c79f7"
          />
          <path
            d="M112.453 557.058a2.002 2.002 0 0 1-1.666-.893l-18.601-27.996a2 2 0 0 1 1.439-3.094c36.843-4.217 68.013-31.619 74.115-65.156a2.001 2.001 0 0 1 3.643-.734l18.557 28.492c.239.367.352.803.318 1.24-1.218 16.365-9.745 32.341-24.01 44.985-14.381 12.747-33.41 20.966-53.581 23.144a1.95 1.95 0 0 1-.215.012zm-15.162-28.435 16.15 24.308c38.328-4.635 70.029-32.328 72.774-63.644l-15.57-23.907c-8.104 32.075-37.944 57.907-73.354 63.243z"
            fill="#0b122d"
          />
          <path
            d="M590.976 216.317c13.556-19.457 22.421-42.928 25.357-69.767 8.169-74.681-86.31-151.673-156.548-99.7-51.441 38.064-68.231 131.997-50.568 178.783 16.47 43.627 68.188 59.754 113.319 42.843 14.05-5.265 26.931-12.295 38.368-20.948"
            fill="#c66a52"
          />
          <path
            d="M486.509 277.104c-11.009 0-21.85-1.818-32.054-5.464-22.368-7.993-39.1-24.081-47.11-45.3-8.904-23.586-9.172-59.547-.7-93.849 9.513-38.514 27.962-69.499 51.95-87.249 29.71-21.982 66.468-23.267 100.846-3.522 38.983 22.391 63.196 65.587 58.881 105.047-2.91 26.605-11.559 50.39-25.705 70.693a2 2 0 1 1-3.281-2.287c13.759-19.747 22.174-42.909 25.01-68.841 4.148-37.928-19.248-79.52-56.896-101.144-32.938-18.918-68.101-17.726-96.475 3.269-23.24 17.197-41.156 47.381-50.445 84.992-8.288 33.557-8.074 68.609.559 91.477 15.426 40.859 64.069 59.169 110.746 41.677 13.86-5.193 26.599-12.147 37.862-20.669a1.999 1.999 0 0 1 2.802.388 1.998 1.998 0 0 1-.388 2.801c-11.572 8.755-24.65 15.897-38.872 21.226-12.006 4.499-24.471 6.754-36.729 6.754z"
            fill="#0b122d"
          />
          <path
            d="M586.768 183.213c-15.725-8.01-10.937-49.617-23.996-81.967-23.17 2.188-38.069-13.771-61.98-32.002-20.917-15.948-63.809-9.899-80.416 29.387C407.947 63.937 433.156 23.738 470.971 2c0 0-1.886 19.472 2.208 19.62C497.72 3.142 528.31 9.624 549.749 4.259c0 0-2.163 10.795.739 15.46 20.379-5.3 35.101-3.267 52.719-12.76 0 0 7.458 23.18 4.212 44.324 5.734 6.85 6.214 9.16 9.497 17.591l6.709-10.381c13.697 20.99 16.277 47.75 12.349 65.641 0 0 12.547-10.241 12.886-7.043 1.605 15.17-12.012 46.916-18.874 61.188-17.823 37.074-33.561 9.853-43.22 4.933z"
            fill="#0b122d"
          />
          <path
            d="M610.232 199.458c-7.017 0-13.106-5.298-18.115-9.655-2.313-2.012-4.498-3.913-6.256-4.808-9.885-5.035-12.289-21.245-15.072-40.013-1.97-13.281-4.193-28.277-9.334-41.626-19.342 1.21-33.229-9.844-50.695-23.752-3.559-2.834-7.238-5.764-11.18-8.769-9.806-7.475-24.748-9.769-38.996-5.981-17.259 4.586-30.883 16.858-38.364 34.556a2 2 0 0 1-3.724-.105c-13.545-37.806 15.646-78.439 51.48-99.039a2 2 0 0 1 2.987 1.926c-.694 7.191-.518 14.419.334 16.865C489.951 7.194 509.112 6.04 526.068 5.019c8.399-.505 16.332-.983 23.198-2.701a2 2 0 0 1 2.446 2.332c-.492 2.471-1.333 8.996-.105 12.724 6.996-1.717 13.266-2.604 19.343-3.463 11.017-1.558 20.53-2.903 31.312-8.712a2 2 0 0 1 2.852 1.148c.306.952 7.363 23.241 4.415 44.345 4.532 5.513 5.708 8.241 7.843 13.795l4.576-7.079a2 2 0 0 1 1.676-.915h.004c.676 0 1.306.341 1.675.907 12.833 19.667 15.991 44.263 13.55 61.954 7.783-5.748 9.639-4.981 10.399-4.667.896.369 1.494 1.188 1.601 2.194 1.867 17.645-15.55 54.963-19.061 62.265-5.803 12.069-11.936 18.619-18.751 20.024a13.88 13.88 0 0 1-2.808.288zm-22.557-18.027c2.197 1.119 4.562 3.176 7.066 5.354 5.259 4.575 11.22 9.765 17.489 8.468 5.435-1.121 10.802-7.123 15.954-17.84 9.097-18.919 19.213-45.095 18.794-58.52-2.192 1.081-6.372 4.043-9.739 6.791a1.998 1.998 0 0 1-3.217-1.978c3.573-16.278 1.626-41.204-10.427-61.48l-4.999 7.735a2 2 0 0 1-3.543-.36c-.381-.978-.725-1.873-1.042-2.704-2.378-6.205-3.267-8.526-8.125-14.329a1.996 1.996 0 0 1-.443-1.587c2.555-16.639-1.757-34.843-3.478-41.128-10.552 5.206-20.239 6.576-30.457 8.021-6.432.909-13.082 1.85-20.516 3.783a1.999 1.999 0 0 1-2.201-.879c-2.302-3.698-1.952-10.115-1.476-13.924-6.466 1.286-13.559 1.712-21.01 2.161-16.841 1.014-35.929 2.163-51.923 14.205a2.002 2.002 0 0 1-1.275.401c-.651-.023-1.604-.253-2.442-1.211-2.377-2.715-2.314-11.186-1.986-16.713-31.321 19.338-56.36 54.195-47.916 87.369 8.308-16.289 21.92-27.592 38.792-32.075 15.415-4.098 31.682-1.543 42.449 6.666 3.975 3.03 7.671 5.974 11.245 8.82 17.883 14.241 30.807 24.524 49.334 22.78a1.997 1.997 0 0 1 2.043 1.243c5.702 14.125 8.048 29.943 10.118 43.898 2.621 17.673 4.884 32.937 12.932 37.035z"
            fill="#0b122d"
          />
          <path
            d="M580.873 182.261c5.731-11.718 19.1-18.173 32.205-14.743 14.947 3.912 23.892 19.2 19.981 34.147-3.912 14.947-19.2 23.892-34.147 19.981a27.847 27.847 0 0 1-13.282-7.878"
            fill="#c66a52"
          />
          <g fill="#0b122d">
            <path d="M606.047 224.569c-2.547 0-5.111-.328-7.641-.989a29.891 29.891 0 0 1-14.232-8.443 2 2 0 1 1 2.914-2.74 25.892 25.892 0 0 0 12.331 7.313c6.711 1.758 13.707.796 19.695-2.709 5.988-3.504 10.254-9.13 12.011-15.842 3.626-13.856-4.696-28.079-18.553-31.706-11.921-3.122-24.496 2.637-29.901 13.688a2 2 0 0 1-3.594-1.758c6.239-12.754 20.754-19.398 34.508-15.8 15.99 4.186 25.595 20.599 21.409 36.588-2.027 7.746-6.949 14.238-13.86 18.282-4.653 2.723-9.834 4.116-15.087 4.116zm-91.77-70.86c-7.356-4.867-15.235-7.504-24.884-10.249-6.187-1.76-5.352-8.903 4.009-11.407 8.798-2.353 24.571 3.718 28.689 12.146 4.295 8.792-1.81 13.482-7.814 9.509z" />
            <path d="M518.574 157.134c-1.754 0-3.631-.586-5.4-1.757-6.811-4.507-14.077-7.077-24.327-9.993-3.367-.958-5.444-3.378-5.421-6.316.024-3.109 2.522-7.091 9.46-8.947 9.284-2.483 26.308 3.591 31.002 13.201 2.895 5.924 1.501 10.164-.768 12.155-1.26 1.105-2.845 1.656-4.546 1.656zm-3.193-5.093c1.936 1.28 3.938 1.452 5.101.43 1.158-1.017 1.718-3.494-.188-7.393-3.785-7.748-18.719-13.139-26.375-11.092-4.443 1.188-6.48 3.484-6.493 5.114-.009 1.091.908 1.979 2.515 2.437 10.627 3.023 18.198 5.712 25.44 10.504zm-66.064-14.872c-8.817-.257-16.902 1.657-26.548 4.412-6.185 1.767-9.242-4.743-2.608-11.806 6.236-6.638 22.839-9.796 30.781-4.806 8.286 5.206 5.57 12.41-1.626 12.2z" />
            <path d="M420.813 143.871c-2.321 0-4.293-1.009-5.431-2.875-1.618-2.655-1.596-7.356 3.32-12.59 6.578-7.002 24.246-10.821 33.304-5.13 5.583 3.508 6.634 7.845 5.756 10.733-.99 3.255-4.3 5.287-8.505 5.158-8.16-.241-15.694 1.409-25.938 4.336a9.12 9.12 0 0 1-2.506.367zm19.874-19.37c-7.21 0-15.421 2.76-19.068 6.643-3.148 3.352-3.67 6.377-2.821 7.769.566.932 1.812 1.202 3.422.745 10.622-3.034 18.463-4.739 27.155-4.489 2.291.057 4.11-.844 4.561-2.323.448-1.475-.382-3.875-4.058-6.184-2.394-1.504-5.673-2.161-9.19-2.161z" />
            <ellipse
              cx="495.011"
              cy="169.123"
              rx="6.834"
              ry="5.74"
              transform="matrix(.11996357 -.99277829 .99277829 .11996357 267.723 640.27)"
            />
            <ellipse
              cx="435.039"
              cy="163.166"
              rx="6.834"
              ry="5.74"
              transform="matrix(.11996357 -.99277829 .99277829 .11996357 220.86 575.489)"
            />
            <path d="M494.154 219.943c-3.917 0-7.801-.814-11.27-2.437a2 2 0 1 1 1.693-3.623c5.616 2.625 12.53 2.756 18.495.349 4.873-1.967 8.467-5.424 10.12-9.736a2 2 0 1 1 3.734 1.431c-2.055 5.36-6.443 9.627-12.356 12.014a27.938 27.938 0 0 1-10.417 2.002z" />
          </g>
          <path d="m614.196 191.759-14.908 11.021" fill="#fff" />
          <path
            d="M599.291 204.78a2 2 0 0 1-1.191-3.608l14.907-11.021a2 2 0 1 1 2.379 3.216l-14.907 11.021a1.994 1.994 0 0 1-1.188.392z"
            fill="#0b122d"
          />
          <path d="m612.198 206.159-10.707-17.725" fill="#fff" />
          <path
            d="M612.2 208.159a1.999 1.999 0 0 1-1.714-.966l-10.707-17.725a2 2 0 1 1 3.424-2.068l10.707 17.725a2 2 0 0 1-1.71 3.035z"
            fill="#0b122d"
          />
          <path
            d="M562.77 103.246a2 2 0 0 1-.461-3.947c24.25-5.769 39.166-22.478 43.134-48.32a2 2 0 0 1 3.953.608c-4.234 27.583-20.197 45.428-46.161 51.604a2.008 2.008 0 0 1-.465.055zM462.404 34.163a2 2 0 0 1-1.596-3.204c.175-.232 4.364-5.745 11.159-10.929a2 2 0 1 1 2.426 3.179c-6.336 4.835-10.353 10.106-10.392 10.159a2 2 0 0 1-1.598.794zm56.391 239.901c5.054-7.023 14.054 9.449 44.978 0 36.277-11.084 31.977-34.62 38.719-32.517s13.211 21.723 15.338 29.445c3.157 11.457-24.331 38.273-56.296 43.082-27.959 4.206-38.531-6.802-42.738-9.956-4.206-3.155-4.741-23.466 0-30.054z"
            fill="#fff"
          />
          <path
            d="M549.663 317.015c-18.018 0-26.764-7.043-30.898-10.373a41.09 41.09 0 0 0-1.17-.923c-5.398-4.05-5.676-25.522-.423-32.822 2.878-4.002 6.781-2.641 11.299-1.065 6.651 2.32 16.702 5.824 34.718.321 23.347-7.134 29.093-19.216 32.526-26.436 1.784-3.752 3.471-7.295 7.372-6.078 8.518 2.657 15.381 26.142 16.67 30.823.958 3.475-.263 7.969-3.531 12.997-8.523 13.116-30.484 28.997-54.395 32.594-4.464.672-8.508.962-12.168.962zm-29.245-41.783c-4.37 6.074-3.369 25.076-.423 27.286.375.281.799.622 1.278 1.008 4.952 3.989 15.258 12.286 39.962 8.571 22.756-3.424 43.588-18.434 51.637-30.819 2.589-3.983 3.664-7.448 3.029-9.754-3.549-12.883-9.499-26.661-14.006-28.067a.61.61 0 0 0-.215-.041c-.533.191-1.586 2.403-2.354 4.019-3.473 7.302-9.938 20.894-34.971 28.542-19.263 5.886-30.494 1.97-37.203-.369-4.868-1.698-5.748-1.745-6.735-.375z"
            fill="#0b122d"
          />
          <path
            d="M608.757 248.008c18.332-2.597 34.194.272 45.135 6.157 9.869 5.309 30.886 53.425 35.819 68.636 0 0-39.055-4.933-46.866 10.278s-14.389 48.1-14.389 48.1c.822-51.8-5.453-90.727-19.699-133.17z"
            fill="#5c79f7"
          />
          <path
            d="M628.458 383.178a2 2 0 0 1-2.002-2.032c.798-50.27-4.879-88.658-19.596-132.502a2 2 0 0 1 1.616-2.616c17.612-2.497 34.08-.232 46.362 6.375 10.866 5.844 32.039 55.179 36.774 69.781a2.003 2.003 0 0 1-.361 1.892 2.002 2.002 0 0 1-1.791.709c-10.479-1.321-38.96-2.239-44.837 9.207-7.597 14.792-14.142 47.252-14.207 47.579a2 2 0 0 1-1.959 1.608zM611.421 249.68c12.567 38.095 18.357 72.295 19.04 113.872 2.663-10.447 6.437-23.271 10.604-31.387 7.071-13.772 36.021-12.508 45.746-11.67-6.59-18.552-25.59-60.117-33.867-64.569-10.989-5.911-25.659-8.106-41.523-6.246z"
            fill="#0b122d"
          />
          <ellipse
            cx="492.817"
            cy="467.336"
            fill="#0b122d"
            rx="7.885"
            ry="5.649"
            transform="matrix(.04623474 -.9989306 .9989306 .04623474 3.197 938.02)"
          />
          <path
            d="M492.637 477.216c-.093 0-.186-.002-.278-.006-2.137-.099-4.131-1.338-5.469-3.401-1.222-1.885-1.831-4.309-1.715-6.827.25-5.411 3.653-9.527 7.807-9.527.097 0 .193.002.292.006 2.137.099 4.131 1.339 5.469 3.401 1.222 1.885 1.831 4.309 1.715 6.827-.116 2.518-.947 4.875-2.338 6.639-1.457 1.846-3.441 2.888-5.482 2.888zm.357-15.761c-1.906 0-3.68 2.632-3.822 5.712-.077 1.666.314 3.293 1.075 4.465.368.568 1.157 1.529 2.298 1.582 1.14.053 2.016-.831 2.435-1.363.865-1.097 1.405-2.681 1.482-4.346.077-1.666-.314-3.293-1.075-4.465-.368-.568-1.157-1.529-2.298-1.582a2.948 2.948 0 0 0-.095-.002zm5.466 6.142h.01z"
            fill="#0b122d"
          />
          <ellipse
            cx="479.091"
            cy="564.783"
            fill="#0b122d"
            rx="7.885"
            ry="5.649"
            transform="matrix(.18967812 -.98184633 .98184633 .18967812 -166.314 928.045)"
          />
          <path
            d="M478.361 574.597c-.384 0-.767-.036-1.146-.109-2.101-.406-3.895-1.92-4.921-4.154-.938-2.041-1.191-4.528-.714-7.003.478-2.474 1.639-4.688 3.271-6.233 1.784-1.691 4.012-2.428 6.114-2.021 4.212.814 6.687 5.715 5.636 11.156-.479 2.475-1.64 4.688-3.271 6.233-1.464 1.386-3.225 2.13-4.97 2.13zm1.443-15.631c-.953 0-1.771.627-2.203 1.037-1.014.96-1.777 2.45-2.093 4.087-.316 1.638-.163 3.305.42 4.574.283.615.925 1.68 2.046 1.896 1.123.214 2.114-.532 2.605-.998 1.015-.961 1.777-2.451 2.094-4.088.595-3.078-.558-6.101-2.467-6.47a2.145 2.145 0 0 0-.402-.039z"
            fill="#0b122d"
          />
          <ellipse
            cx="442.585"
            cy="661.74"
            fill="#0b122d"
            rx="7.885"
            ry="5.649"
            transform="matrix(.5 -.8660254 .8660254 .5 -351.791 714.16)"
          />
          <path
            d="M440.812 671.126a6.297 6.297 0 0 1-3.169-.826c-1.854-1.069-3.055-3.086-3.296-5.533-.22-2.236.354-4.669 1.613-6.852 2.772-4.799 7.853-6.878 11.567-4.736 3.714 2.146 4.452 7.586 1.682 12.386-1.26 2.183-3.081 3.895-5.127 4.823-1.088.493-2.201.739-3.271.739zm3.552-14.776c-1.637 0-3.693 1.408-4.938 3.565-.834 1.444-1.233 3.069-1.097 4.46.066.674.325 1.89 1.314 2.46.988.571 2.171.188 2.788-.092 1.272-.577 2.48-1.735 3.313-3.179 1.568-2.715 1.467-5.949-.217-6.921a2.297 2.297 0 0 0-1.164-.293z"
            fill="#0b122d"
          />
          <path
            d="M785.988 309.1c38.736 37.214 67.342 115.493 75.363 156.376 6.292 31.275-4.267 51.449-2.405 78.991 2.26 33.439-3.001 62.788-15.636 87.233-31.62 63.157-138.263 111.95-140.684 185.57-.562 24.166-18.183 43.93-41.084 48.048-30.617 5.805-59.995-19.104-58.887-50.375 2.819-112.659 99.229-162.598 151.824-229.161 19.71-37.453 6.641-136-24.892-186.511"
            fill="#c66a52"
          />
          <path
            d="M652.54 868.167c-12.166 0-24.103-4.427-33.767-12.723-12.061-10.353-18.664-25.141-18.118-40.571 2.057-82.177 52.574-130.498 101.429-177.227 18.621-17.812 36.212-34.637 50.71-52.957 19.193-36.831 5.966-134.911-24.903-184.358a2 2 0 1 1 3.393-2.118c14.941 23.934 26.885 60.923 31.948 98.948 5.077 38.121 2.466 71.599-6.983 89.554a2.005 2.005 0 0 1-.2.308c-14.692 18.595-32.425 35.556-51.199 53.514-48.268 46.169-98.18 93.91-100.195 174.457-.503 14.229 5.593 27.858 16.726 37.415 11.211 9.625 25.715 13.615 39.791 10.945 22.343-4.018 38.929-23.417 39.457-46.13 1.46-44.4 39.979-79.836 77.229-114.106 26.182-24.087 50.911-46.837 63.666-72.313 12.477-24.138 17.664-53.133 15.43-86.203-.8-11.835.672-22.467 2.096-32.749 1.924-13.887 3.912-28.247.344-45.982-8.382-42.719-37.124-119.144-74.788-155.328a2 2 0 1 1 2.771-2.885c38.292 36.789 67.459 114.209 75.94 157.433 3.7 18.392 1.664 33.093-.305 47.311-1.461 10.545-2.84 20.506-2.068 31.931 2.285 33.809-3.05 63.513-15.855 88.287-13.071 26.108-39.228 50.172-64.522 73.443-36.644 33.711-74.534 68.571-75.938 111.275-.571 24.586-18.542 45.602-42.729 49.951-3.11.59-6.24.88-9.355.88z"
            fill="#0b122d"
          />
          <path
            d="M769.578 274.897c39.64 16.938 82.878 70.621 111.377 186.637 23 119.116 2.318 185.983-85.617 251.484-23.563 17.551-38.994 29.167-52.46 46.099-14.368 18.066-28.395 25.412-48.363 29.003-15.328 2.756-31.664.441-46.341-7.712-35.198-22.421-44.455-45.547-33.117-72.779 17.467-41.952 52.242-67.129 81.906-93.263 13.883-12.231 35.636-29.817 39.745-37.767 4.316-8.35 15.324-46.081 7-87.441-5.875-29.185-17.277-57.366-31.467-78.925"
            fill="#5c79f7"
          />
          <path
            d="M682.216 791.213a72.197 72.197 0 0 1-35.014-9.058c-.034-.02-.069-.04-.103-.062-35.165-22.4-45.934-46.307-33.889-75.235 15.128-36.337 42.695-59.908 69.354-82.703 4.329-3.702 8.805-7.529 13.076-11.292 2.833-2.496 5.951-5.179 9.253-8.019 12.004-10.327 26.942-23.178 30.038-29.167 4.641-8.979 14.878-46.069 6.815-86.128-5.769-28.66-16.84-56.44-31.177-78.221a2 2 0 1 1 3.342-2.199c14.611 22.199 25.89 50.479 31.757 79.631 8.273 41.11-2.371 79.442-7.185 88.754-3.451 6.678-17.447 18.718-30.982 30.362-3.292 2.832-6.401 5.507-9.217 7.987-4.294 3.783-8.781 7.62-13.121 11.331-26.303 22.49-53.5 45.745-68.261 81.2-11.311 27.165-1.353 48.844 32.293 70.292 13.658 7.571 29.621 10.22 44.964 7.463 20.708-3.724 33.929-11.653 47.151-28.279 13.861-17.43 30.207-29.605 52.831-46.458 85.854-63.95 108.062-129.228 84.857-249.452-13.237-53.87-30.477-97.547-51.238-129.818-17.786-27.646-37.627-46.287-58.971-55.407a2 2 0 0 1-1.053-2.625 1.993 1.993 0 0 1 2.625-1.053c22.092 9.44 42.535 28.591 60.763 56.921 21.008 32.653 38.426 76.754 51.771 131.077.008.032.015.065.021.098 12.103 62.681 11.71 107.974-1.274 146.86-13.103 39.238-40.147 73.114-85.112 106.607-22.381 16.672-38.552 28.717-52.089 45.74-13.898 17.476-27.798 25.81-49.575 29.726a71.54 71.54 0 0 1-12.652 1.126z"
            fill="#0b122d"
          />
          <path
            d="M715.336 775.438c-7.495 13.149-12.222 26.986-12.71 41.833-.562 24.166-18.183 43.93-41.084 48.048-30.617 5.805-59.995-19.104-58.887-50.375.512-20.473 4.115-38.875 9.985-55.682 39.557-9.519 73.651-3.74 102.697 16.175z"
            fill="#c66a52"
          />
          <path
            d="M652.54 868.167c-12.166 0-24.103-4.427-33.767-12.723-12.061-10.353-18.664-25.141-18.118-40.571.497-19.826 3.799-38.239 10.096-56.27a2.002 2.002 0 0 1 1.421-1.285c39.428-9.489 74.518-3.947 104.296 16.47a1.999 1.999 0 0 1 .606 2.64c-7.929 13.909-12.001 27.29-12.449 40.908-.571 24.586-18.542 45.602-42.729 49.951-3.11.59-6.24.88-9.355.88zm-38.369-107.212c-5.926 17.304-9.04 34.994-9.518 54.04-.503 14.229 5.593 27.858 16.726 37.415 11.21 9.625 25.708 13.614 39.791 10.945 22.343-4.018 38.929-23.417 39.457-46.13.452-13.77 4.402-27.246 12.065-41.159-28.212-18.73-61.344-23.814-98.521-15.11z"
            fill="#0b122d"
          />
          <path
            d="M602.654 814.944c.077 25.412 6.684 53.625 21.592 70.621 10.45 11.915 25.397 21.374 38.693 25.717 13.513 4.414 25.363-13.467 14.135-26.281-5.745-6.557-13.357-10.119-17.615-17.304-3.861-6.516-6.76-15.313-3.34-25.929"
            fill="#c66a52"
          />
          <path
            d="M667.172 913.968c-1.605 0-3.237-.256-4.854-.784-14.271-4.662-29.436-14.739-39.575-26.299-13.742-15.667-22-42.559-22.089-71.935a2.001 2.001 0 0 1 1.994-2.006h.006a2 2 0 0 1 2 1.994c.086 28.437 7.973 54.347 21.097 69.309 9.693 11.052 24.181 20.683 37.81 25.134 5.092 1.667 10.438-.361 13.609-5.165 2.791-4.228 4.048-11.452-1.599-17.897-2.276-2.597-4.938-4.765-7.511-6.862-3.762-3.064-7.65-6.233-10.321-10.74-5.331-8.996-6.517-18.269-3.522-27.562a2 2 0 1 1 3.807 1.226c-2.663 8.27-1.631 16.217 3.157 24.296 2.308 3.894 5.756 6.704 9.406 9.678 2.702 2.201 5.495 4.478 7.992 7.328 5.869 6.698 6.626 15.622 1.929 22.736-3.204 4.853-8.13 7.547-13.336 7.547z"
            fill="#0b122d"
          />
          <path
            d="M634.456 837.713c.205 11.988 5.324 30.251 23.108 42.092 13.729 9.141 25.651 11.513 41.431 11.722 13.987.185 14.554-20.077 2.415-27.008-9.674-5.523-14.837-6.788-19.483-12.612s-6.88-22.262-6.88-22.262"
            fill="#c66a52"
          />
          <path
            d="m699.181 893.528-.213-.001c-15.372-.204-27.847-2.292-42.513-12.058-21.823-14.529-23.887-37.138-24-43.722a2 2 0 0 1 1.966-2.034h.035a2 2 0 0 1 1.999 1.966c.104 6.091 2.014 27.01 22.217 40.461 13.848 9.22 25.705 11.193 40.349 11.387l.168.001c5.782 0 7.745-4.017 8.402-6.428 1.478-5.423-.802-13.207-7.173-16.844-2.74-1.564-5.128-2.79-7.234-3.871-5.365-2.753-9.241-4.743-12.821-9.231-4.933-6.185-7.203-22.546-7.297-23.24a1.998 1.998 0 0 1 1.712-2.25 1.997 1.997 0 0 1 2.251 1.712c.603 4.422 2.937 16.865 6.461 21.284 3.044 3.816 6.416 5.547 11.521 8.167 2.144 1.101 4.574 2.348 7.391 3.956 8.359 4.772 10.901 14.572 9.05 21.369-1.604 5.884-6.183 9.376-12.27 9.376z"
            fill="#0b122d"
          />
          <path
            d="M667.049 827.275c1.364 11.999 12.359 30.853 28.058 39.544 11.941 6.61 24.929 4.869 33.822 3.923 18.797-1.999 14.19-23.226-2.524-28.463-16.237-5.088-22.846-13.047-23.779-25.007"
            fill="#c66a52"
          />
          <path
            d="M715.842 873.688c-6.865 0-14.403-1.078-21.704-5.119-16.089-8.907-27.62-28.252-29.077-41.068a2 2 0 0 1 1.762-2.213 2.008 2.008 0 0 1 2.213 1.761c1.351 11.88 12.538 29.992 27.04 38.02 10.896 6.032 22.816 4.745 31.519 3.804l1.122-.121c6.215-.661 9.892-3.589 10.354-8.244.575-5.8-4.229-13.491-13.263-16.322-16.368-5.129-24.133-13.382-25.176-26.761a2 2 0 1 1 3.988-.31c.91 11.668 7.604 18.623 22.383 23.254 9.999 3.134 16.897 11.961 16.048 20.535-.649 6.548-5.85 10.969-13.91 11.826l-1.116.12c-3.618.391-7.761.838-12.182.838z"
            fill="#0b122d"
          />
          <path
            d="M617.487 746.881c-4.924 11.857-8.531 22.578-10.409 31.809 35.592-20.914 81.341-10.344 99.09 17.641 2.732-9.776 8.279-20.208 15.58-31.049-12.041-31.938-74.707-48.958-104.261-18.401z"
            fill="#5c79f7"
          />
          <path
            d="M706.168 798.33a1.997 1.997 0 0 1-1.688-.929c-18.122-28.572-63.163-36.512-96.388-16.988a2 2 0 0 1-2.974-2.123c1.837-9.027 5.278-19.553 10.522-32.177.096-.231.234-.443.409-.624 13.792-14.26 36.272-19.825 60.127-14.889 22.819 4.723 41.442 18.059 47.442 33.976a2.001 2.001 0 0 1-.212 1.823c-7.818 11.609-12.827 21.576-15.313 30.47a1.998 1.998 0 0 1-1.926 1.461zm-58.103-32.609c22.855 0 44.801 9.202 57.422 26.1 2.783-8.033 7.396-16.844 14.015-26.78-5.911-14.248-23.091-26.167-44.136-30.523-22.353-4.625-43.319.414-56.179 13.484-4.187 10.116-7.264 19.104-9.176 26.794 11.96-6.14 25.153-9.074 38.054-9.074z"
            fill="#0b122d"
          />
          <path
            d="M257.382 537.85c13.42 5.138 24.377 3.53 24.377 3.53"
            fill="#5c79f7"
          />
          <path
            d="M277.334 543.624c-4.604 0-12.138-.641-20.667-3.907a2 2 0 1 1 1.43-3.736c12.724 4.871 23.271 3.432 23.376 3.418a1.999 1.999 0 0 1 .577 3.958c-.178.026-1.897.266-4.716.266z"
            fill="#0b122d"
          />
        </svg>
      </g>
    </svg>
  ),
  Print: ({ ...props }: LucideProps) => (
    <svg
      width="104"
      height="105"
      viewBox="0 0 104 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M87.0867 6.47363H17C14.7909 6.47363 13 8.26449 13 10.4736V36.1136H91.0867V10.4736C91.0867 8.26449 89.2958 6.47363 87.0867 6.47363Z"
        fill="#26AA68"
      />
      <path
        d="M80.1533 0.666992H23.8467C21.6375 0.666992 19.8467 2.45785 19.8467 4.66699V36.1137H84.1533V4.66699C84.1533 2.45785 82.3625 0.666992 80.1533 0.666992Z"
        fill="#BDFFDE"
      />
      <path
        d="M96 28.4004H8C3.58172 28.4004 0 31.9821 0 36.4004V83.0604C0 87.4787 3.58172 91.0604 8 91.0604H96C100.418 91.0604 104 87.4787 104 83.0604V36.4004C104 31.9821 100.418 28.4004 96 28.4004Z"
        fill="#19DE7C"
      />
      <path
        d="M83.0867 61.1602H21C16.5817 61.1602 13 64.7419 13 69.1602V91.0602H91.0867V69.1602C91.0867 64.7419 87.5049 61.1602 83.0867 61.1602Z"
        fill="#26AA68"
      />
      <path
        d="M85.3233 41.1406H18.7633C15.5803 41.1406 13 43.721 13 46.904C13 50.087 15.5803 52.6673 18.7633 52.6673H85.3233C88.5063 52.6673 91.0867 50.087 91.0867 46.904C91.0867 43.721 88.5063 41.1406 85.3233 41.1406Z"
        fill="#26AA68"
      />
      <path
        d="M84.1533 61.0732H19.8467V100.667C19.8467 102.876 21.6375 104.667 23.8467 104.667H80.1533C82.3625 104.667 84.1533 102.876 84.1533 100.667V61.0732Z"
        fill="#BDFFDE"
      />
      <path
        d="M84.1537 49.4607C85.5897 49.4607 86.7537 48.2967 86.7537 46.8607C86.7537 45.4248 85.5897 44.2607 84.1537 44.2607C82.7178 44.2607 81.5537 45.4248 81.5537 46.8607C81.5537 48.2967 82.7178 49.4607 84.1537 49.4607Z"
        fill="#BDFFDE"
      />
      <path
        d="M38.5669 68.6143H27.8202C26.863 68.6143 26.0869 69.3903 26.0869 70.3476C26.0869 71.3049 26.863 72.0809 27.8202 72.0809H38.5669C39.5242 72.0809 40.3002 71.3049 40.3002 70.3476C40.3002 69.3903 39.5242 68.6143 38.5669 68.6143Z"
        fill="#26AA68"
      />
      <path
        d="M53.8202 75.8066H27.8202C26.863 75.8066 26.0869 76.5827 26.0869 77.54C26.0869 78.4973 26.863 79.2733 27.8202 79.2733H53.8202C54.7775 79.2733 55.5536 78.4973 55.5536 77.54C55.5536 76.5827 54.7775 75.8066 53.8202 75.8066Z"
        fill="#26AA68"
      />
      <path
        d="M46.5402 83.001H27.8202C26.863 83.001 26.0869 83.777 26.0869 84.7343C26.0869 85.6916 26.863 86.4676 27.8202 86.4676H46.5402C47.4975 86.4676 48.2736 85.6916 48.2736 84.7343C48.2736 83.777 47.4975 83.001 46.5402 83.001Z"
        fill="#26AA68"
      />
    </svg>
  ),
  Email: ({ ...props }: LucideProps) => (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_358_5680)">
        <path
          d="M104 77.2194H0V39.6061L52 10.0527L104 39.6061V77.2194Z"
          fill="#F6B445"
        />
        <path
          d="M82.2203 0H21.7803C17.362 0 13.7803 3.58173 13.7803 8V77.22H90.2203V8C90.2203 3.58172 86.6385 0 82.2203 0Z"
          fill="#FCF4DC"
        />
        <path
          d="M38.5669 18.2871H27.8202C26.863 18.2871 26.0869 19.0631 26.0869 20.0204C26.0869 20.9777 26.863 21.7538 27.8202 21.7538H38.5669C39.5242 21.7538 40.3002 20.9777 40.3002 20.0204C40.3002 19.0631 39.5242 18.2871 38.5669 18.2871Z"
          fill="#F6B445"
        />
        <path
          d="M53.8202 25.4805H27.8202C26.863 25.4805 26.0869 26.2565 26.0869 27.2138C26.0869 28.1711 26.863 28.9471 27.8202 28.9471H53.8202C54.7775 28.9471 55.5536 28.1711 55.5536 27.2138C55.5536 26.2565 54.7775 25.4805 53.8202 25.4805Z"
          fill="#F6B445"
        />
        <path
          d="M46.5402 32.6738H27.8202C26.863 32.6738 26.0869 33.4499 26.0869 34.4072C26.0869 35.3645 26.863 36.1405 27.8202 36.1405H46.5402C47.4975 36.1405 48.2736 35.3645 48.2736 34.4072C48.2736 33.4499 47.4975 32.6738 46.5402 32.6738Z"
          fill="#F6B445"
        />
        <path
          d="M104 96.0008C104 100.419 100.418 104.001 96 104.001H8C3.58172 104.001 0 100.419 0 96.0008V39.6074L33.8867 67.6008H70.1133L104 39.6074V96.0008Z"
          fill="#FED049"
        />
        <path
          d="M33.973 67.5137L16.293 90.7403"
          stroke="#F6B445"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M70.0264 67.5137L87.7064 90.7403"
          stroke="#F6B445"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_358_5680">
          <rect width="104" height="104" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  TextMessage: ({ ...props }: LucideProps) => (
    <svg
      width="104"
      height="105"
      viewBox="0 0 104 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_358_5695)">
        <path
          d="M95.9996 0.332031H24.293C19.8747 0.332031 16.293 3.91375 16.293 8.33203V55.1654C16.293 59.5836 19.8747 63.1654 24.293 63.1654H95.9996C100.418 63.1654 104 59.5836 104 55.1654V8.33203C104 3.91375 100.418 0.332031 95.9996 0.332031Z"
          fill="#8BB7FF"
        />
        <path
          d="M94.2933 99.2458C94.2933 101.063 92.0663 101.938 90.8289 100.608L81.6732 90.7643C80.1597 89.1371 78.0376 88.2127 75.8154 88.2127H7.99999C3.58172 88.2127 0 84.631 0 80.2127V20.5527C0 16.1345 3.58172 12.5527 8 12.5527H86.2934C90.7116 12.5527 94.2933 16.1345 94.2933 20.5527V99.2458Z"
          fill="#355FE5"
        />
        <path
          d="M30.7669 55.3658C33.5431 55.3658 35.7936 53.1153 35.7936 50.3392C35.7936 47.563 33.5431 45.3125 30.7669 45.3125C27.9907 45.3125 25.7402 47.563 25.7402 50.3392C25.7402 53.1153 27.9907 55.3658 30.7669 55.3658Z"
          fill="#CBDDFB"
        />
        <path
          d="M47.1468 55.3658C49.9229 55.3658 52.1735 53.1153 52.1735 50.3392C52.1735 47.563 49.9229 45.3125 47.1468 45.3125C44.3706 45.3125 42.1201 47.563 42.1201 50.3392C42.1201 53.1153 44.3706 55.3658 47.1468 55.3658Z"
          fill="#CBDDFB"
        />
        <path
          d="M63.5267 55.3658C66.3028 55.3658 68.5533 53.1153 68.5533 50.3392C68.5533 47.563 66.3028 45.3125 63.5267 45.3125C60.7505 45.3125 58.5 47.563 58.5 50.3392C58.5 53.1153 60.7505 55.3658 63.5267 55.3658Z"
          fill="#CBDDFB"
        />
      </g>
      <defs>
        <clipPath id="clip0_358_5695">
          <rect
            width="104"
            height="104"
            fill="white"
            transform="translate(0 0.332031)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
};
